/* eslint-disable */
const descriptors = [
  { id: 'a largo plazo', label: 'a largo plazo' },
  { id: 'aborto', label: 'aborto' },
  { id: 'aborto libre', label: 'aborto libre' },
  { id: 'interrrupción voluntaria del embarazo', label: 'interrrupción voluntaria del embarazo' },
  { id: 'abusos', label: 'abusos' },
  { id: 'abuso de poder', label: 'abuso de poder' },
  { id: 'accesibilidad', label: 'accesibilidad' },
  { id: 'acceso gratuito', label: 'acceso gratuito' },
  { id: 'acceso igualitario', label: 'acceso igualitario' },
  { id: 'acceso oportuno', label: 'acceso oportuno' },
  { id: 'acceso universal', label: 'acceso universal' },
  { id: 'acceso garantizado', label: 'acceso garantizado' },
  { id: 'accidentes del trabajo', label: 'accidentes del trabajo' },
  { id: 'acoso', label: 'acoso' },
  { id: 'acoso callejero', label: 'acoso callejero' },
  { id: 'actividades productivas', label: 'actividades productivas' },
  { id: 'actividades económicas', label: 'actividades económicas' },
  { id: 'procesos productivos', label: 'procesos productivos' },
  { id: 'actos administrativos', label: 'actos administrativos' },
  { id: 'actual constitución', label: 'actual constitución' },
  { id: 'actualidad', label: 'actualidad' },
  { id: 'acusación constitucional', label: 'acusación constitucional' },
  { id: 'adecuar', label: 'adecuar' },
  { id: 'administración eficiente', label: 'administración eficiente' },
  { id: 'administrar', label: 'administrar' },
  { id: 'adopción', label: 'adopción' },
  { id: 'adultos mayores', label: 'adultos mayores' },
  { id: 'tercera edad', label: 'tercera edad' },
  { id: 'ancianos', label: 'ancianos' },
  { id: 'adultos	mayores', label: 'adultos	mayores' },
  { id: 'afp', label: 'afp' },
  { id: 'agricultura', label: 'agricultura' },
  { id: 'producción agrícola', label: 'producción agrícola' },
  { id: 'agua', label: 'agua' },
  { id: 'uso del agua', label: 'uso del agua' },
  { id: 'nacionalización del agua', label: 'nacionalización del agua' },
  { id: 'agua dulce', label: 'agua dulce' },
  { id: 'agua potable', label: 'agua potable' },
  { id: 'agua superficial', label: 'agua superficial' },
  { id: 'recursos hídricos', label: 'recursos hídricos' },
  { id: 'alcalde', label: 'alcalde' },
  { id: 'alcantarillado', label: 'alcantarillado' },
  { id: 'alimentación', label: 'alimentación' },
  { id: 'alta dirección pública', label: 'alta dirección pública' },
  { id: 'ámbito privado', label: 'ámbito privado' },
  { id: 'privado', label: 'privado' },
  { id: 'ámbito público', label: 'ámbito público' },
  { id: 'público', label: 'público' },
  { id: 'amenazas', label: 'amenazas' },
  { id: 'agresión externa', label: 'agresión externa' },
  { id: 'amistad', label: 'amistad' },
  { id: 'amistad cívica', label: 'amistad cívica' },
  { id: 'amor', label: 'amor' },
  { id: 'ancestrales', label: 'ancestrales' },
  { id: 'derechos ancestrales', label: 'derechos ancestrales' },
  { id: 'medicina ancestral', label: 'medicina ancestral' },
  { id: 'animales', label: 'animales' },
  { id: 'mascotas', label: 'mascotas' },
  { id: 'vida animal', label: 'vida animal' },
  { id: 'especies animales', label: 'especies animales' },
  { id: 'maltrato animal', label: 'maltrato animal' },
  { id: 'antepasados', label: 'antepasados' },
  { id: 'aportar', label: 'aportar' },
  { id: 'apoyar', label: 'apoyar' },
  { id: 'árboles', label: 'árboles' },
  { id: 'árboles nativos', label: 'árboles nativos' },
  { id: 'áreas verdes', label: 'áreas verdes' },
  { id: 'armas', label: 'armas' },
  { id: 'armonía', label: 'armonía' },
  { id: 'arte', label: 'arte' },
  { id: 'asamblea constituyente', label: 'asamblea constituyente' },
  { id: 'asambleas regionales', label: 'asambleas regionales' },
  { id: 'asambleas provinciales', label: 'asambleas provinciales' },
  { id: 'asistencia', label: 'asistencia' },
  { id: 'asistencia técnica', label: 'asistencia técnica' },
  { id: 'asistencia médica', label: 'asistencia médica' },
  { id: 'asistencialismo', label: 'asistencialismo' },
  { id: 'asociatividad', label: 'asociatividad' },
  { id: 'asociarse', label: 'asociarse' },
  { id: 'atención de calidad', label: 'atención de calidad' },
  { id: 'atención digna', label: 'atención digna' },
  { id: 'atención gratuita', label: 'atención gratuita' },
  { id: 'atención oportuna', label: 'atención oportuna' },
  { id: 'autodeterminación', label: 'autodeterminación' },
  { id: 'libre determinación', label: 'libre determinación' },
  { id: 'autogestión', label: 'autogestión' },
  { id: 'autonomía', label: 'autonomía' },
  { id: 'mayor autonomía', label: 'mayor autonomía' },
  { id: 'grados de autonomía', label: 'grados de autonomía' },
  { id: 'autonomía administrativa', label: 'autonomía administrativa' },
  { id: 'autonomía económica', label: 'autonomía económica' },
  { id: 'autonomía individual', label: 'autonomía individual' },
  { id: 'autonomía local', label: 'autonomía local' },
  { id: 'autonomía regional', label: 'autonomía regional' },
  { id: 'autonomía territorial', label: 'autonomía territorial' },
  { id: 'autoridades regionales', label: 'autoridades regionales' },
  { id: 'intendente', label: 'intendente' },
  { id: 'gore', label: 'gore' },
  { id: 'core', label: 'core' },
  { id: 'autorrealización', label: 'autorrealización' },
  { id: 'auto conocimiento', label: 'auto conocimiento' },
  { id: 'auto valorarse', label: 'auto valorarse' },
  { id: 'ayuda mutua', label: 'ayuda mutua' },
  { id: 'ayudar solidariamente', label: 'ayudar solidariamente' },
  { id: 'ayudar', label: 'ayudar' },
  { id: 'banco central', label: 'banco central' },
  { id: 'bancos', label: 'bancos' },
  { id: 'barrios', label: 'barrios' },
  { id: 'barrio digno', label: 'barrio digno' },
  { id: 'barrios seguros	calles', label: 'barrios seguros	calles' },
  { id: 'basura', label: 'basura' },
  { id: 'beneficio personal', label: 'beneficio personal' },
  { id: 'congreso bicameral', label: 'congreso bicameral' },
  { id: 'bicameral', label: 'bicameral' },
  { id: 'bien común', label: 'bien común' },
  { id: 'sentido comunitario', label: 'sentido comunitario' },
  { id: 'bienes de consumo', label: 'bienes de consumo' },
  { id: 'bien de consumo', label: 'bien de consumo' },
  { id: 'bienestar', label: 'bienestar' },
  { id: 'bienestar físico', label: 'bienestar físico' },
  { id: 'bienestar social', label: 'bienestar social' },
  { id: 'biodiversidad', label: 'biodiversidad' },
  { id: 'bosques', label: 'bosques' },
  { id: 'bosques nativos', label: 'bosques nativos' },
  { id: 'buen trato', label: 'buen trato' },
  { id: 'buen vivir', label: 'buen vivir' },
  { id: 'buena fe', label: 'buena fe' },
  { id: 'buenas costumbres', label: 'buenas costumbres' },
  { id: 'burocracia', label: 'burocracia' },
  { id: 'calidad', label: 'calidad' },
  { id: 'calidad de vida', label: 'calidad de vida' },
  { id: 'cámara de diputados', label: 'cámara de diputados' },
  { id: 'diputados', label: 'diputados' },
  { id: 'cámara del senado', label: 'cámara del senado' },
  { id: 'senadores', label: 'senadores' },
  { id: 'senado', label: 'senado' },
  { id: 'cambiar', label: 'cambiar' },
  { id: 'cambio climático', label: 'cambio climático' },
  { id: 'calentamiento global', label: 'calentamiento global' },
  { id: 'clima', label: 'clima' },
  { id: 'desertificación', label: 'desertificación' },
  { id: 'cambio cultural', label: 'cambio cultural' },
  { id: 'campamentos', label: 'campamentos' },
  { id: 'campañas', label: 'campañas' },
  { id: 'campo', label: 'campo' },
  { id: 'personas con discapacidad', label: 'personas con discapacidad' },
  { id: 'discapacidad física', label: 'discapacidad física' },
  { id: 'discapacidad psíquica', label: 'discapacidad psíquica' },
  { id: 'capacidades diferentes', label: 'capacidades diferentes' },
  { id: 'capital humano', label: 'capital humano' },
  { id: 'carencias', label: 'carencias' },
  { id: 'cargos públicos', label: 'cargos públicos' },
  { id: 'autoridades públicas', label: 'autoridades públicas' },
  { id: 'carrera funcionaria', label: 'carrera funcionaria' },
  { id: 'catástrofes', label: 'catástrofes' },
  { id: 'catástrofes naturales', label: 'catástrofes naturales' },
  { id: 'desastres', label: 'desastres' },
  { id: 'emergencias', label: 'emergencias' },
  { id: 'centralismo', label: 'centralismo' },
  { id: 'cesantía', label: 'cesantía' },
  { id: 'chile', label: 'chile' },
  { id: 'ciclos vitales', label: 'ciclos vitales' },
  { id: 'ciencias', label: 'ciencias' },
  { id: 'investigación científica', label: 'investigación científica' },
  { id: 'ciudad', label: 'ciudad' },
  { id: 'urbano', label: 'urbano' },
  { id: 'desarrollo urbano', label: 'desarrollo urbano' },
  { id: 'ciudadanía', label: 'ciudadanía' },
  { id: 'clase media', label: 'clase media' },
  { id: 'clase política', label: 'clase política' },
  { id: 'clases sociales', label: 'clases sociales' },
  { id: 'clase social', label: 'clase social' },
  { id: 'posición social', label: 'posición social' },
  { id: 'ricos', label: 'ricos' },
  { id: 'ciudadanos de', label: 'ciudadanos de' },
  { id: 'primera	elite', label: 'primera	elite' },
  { id: 'estatus social', label: 'estatus social' },
  { id: 'poderosos', label: 'poderosos' },
  { id: 'clientelismo', label: 'clientelismo' },
  { id: 'clientelismo político', label: 'clientelismo político' },
  { id: 'cobertura', label: 'cobertura' },
  { id: 'cobertura universal', label: 'cobertura universal' },
  { id: 'cobre', label: 'cobre' },
  { id: 'excedentes del cobre', label: 'excedentes del cobre' },
  { id: 'código civil', label: 'código civil' },
  { id: 'código del trabajo', label: 'código del trabajo' },
  { id: 'código penal', label: 'código penal' },
  { id: 'cohecho', label: 'cohecho' },
  { id: 'cohesión social', label: 'cohesión social' },
  { id: 'cohesión', label: 'cohesión' },
  { id: 'sociedad cohesionada', label: 'sociedad cohesionada' },
  { id: 'colaboración', label: 'colaboración' },
  { id: 'colusión', label: 'colusión' },
  { id: 'competencia', label: 'competencia' },
  { id: 'compromiso', label: 'compromiso' },
  { id: 'compromiso social', label: 'compromiso social' },
  { id: 'comunal', label: 'comunal' },
  { id: 'asambleas comunales', label: 'asambleas comunales' },
  { id: 'comunicación', label: 'comunicación' },
  { id: 'comunidad', label: 'comunidad' },
  { id: 'comunidad nacional', label: 'comunidad nacional' },
  { id: 'comunidad local', label: 'comunidad local' },
  { id: 'concejales	concejo comunal', label: 'concejales	concejo comunal' },
  { id: 'concesiones', label: 'concesiones' },
  { id: 'condición humana', label: 'condición humana' },
  { id: 'condiciones laborales', label: 'condiciones laborales' },
  { id: 'condiciones materiales', label: 'condiciones materiales' },
  { id: 'condiciones de vida', label: 'condiciones de vida' },
  { id: 'sobrevivencia', label: 'sobrevivencia' },
  { id: 'conectividad', label: 'conectividad' },
  { id: 'confianza', label: 'confianza' },
  { id: 'desconfianza', label: 'desconfianza' },
  { id: 'conflictos', label: 'conflictos' },
  { id: 'conflictos de interés', label: 'conflictos de interés' },
  { id: 'congreso nacional', label: 'congreso nacional' },
  { id: 'congreso', label: 'congreso' },
  { id: 'parlamento', label: 'parlamento' },
  { id: 'rol del congreso', label: 'rol del congreso' },
  { id: 'congreso unicameral', label: 'congreso unicameral' },
  { id: 'parlamento unicameral', label: 'parlamento unicameral' },
  { id: 'conocimiento', label: 'conocimiento' },
  { id: 'conservación del patrimonio', label: 'conservación del patrimonio' },
  { id: 'conservar', label: 'conservar' },
  { id: 'conservar el medioambiente', label: 'conservar el medioambiente' },
  { id: 'medio ambiente sustentable', label: 'medio ambiente sustentable' },
  { id: 'medio ambiente seguro', label: 'medio ambiente seguro' },
  { id: 'conservar la naturaleza', label: 'conservar la naturaleza' },
  { id: 'conservar nuestra identidad', label: 'conservar nuestra identidad' },
  { id: 'constitución', label: 'constitución' },
  { id: 'carta fundamental', label: 'carta fundamental' },
  { id: 'constitución moderna', label: 'constitución moderna' },
  { id: 'constituyentes', label: 'constituyentes' },
  { id: 'construir en conjunto', label: 'construir en conjunto' },
  { id: 'construir el país', label: 'construir el país' },
  { id: 'consultas ciudadanas', label: 'consultas ciudadanas' },
  { id: 'consumo', label: 'consumo' },
  { id: 'consumo humano', label: 'consumo humano' },
  { id: 'contaminación', label: 'contaminación' },
  { id: 'contaminación ambiental', label: 'contaminación ambiental' },
  { id: 'residuos', label: 'residuos' },
  { id: 'residuos peligrosos', label: 'residuos peligrosos' },
  { id: 'contraloría', label: 'contraloría' },
  { id: 'contribuir', label: 'contribuir' },
  { id: 'control de legalidad', label: 'control de legalidad' },
  { id: 'convivencia pacífica', label: 'convivencia pacífica' },
  { id: 'buena convivencia', label: 'buena convivencia' },
  { id: 'sana convivencia', label: 'sana convivencia' },
  { id: 'cooperación', label: 'cooperación' },
  { id: 'corporaciones', label: 'corporaciones' },
  { id: 'corrupción', label: 'corrupción' },
  { id: 'corrupción política', label: 'corrupción política' },
  { id: 'evitar corrupción', label: 'evitar corrupción' },
  { id: 'políticos corruptos', label: 'políticos corruptos' },
  { id: 'corte de apelaciones', label: 'corte de apelaciones' },
  { id: 'corte suprema', label: 'corte suprema' },
  { id: 'cosmovisión', label: 'cosmovisión' },
  { id: 'creatividad', label: 'creatividad' },
  { id: 'crecimiento', label: 'crecimiento' },
  { id: 'crecimiento del país', label: 'crecimiento del país' },
  { id: 'progreso del país', label: 'progreso del país' },
  { id: 'credibilidad', label: 'credibilidad' },
  { id: 'credos religiosos', label: 'credos religiosos' },
  { id: 'convicciones religiosas', label: 'convicciones religiosas' },
  { id: 'creencias personales', label: 'creencias personales' },
  { id: 'convicciones personales', label: 'convicciones personales' },
  { id: 'crianza', label: 'crianza' },
  { id: 'crisis', label: 'crisis' },
  { id: 'crisis económica', label: 'crisis económica' },
  { id: 'cuencas', label: 'cuencas' },
  { id: 'cuencas naturales', label: 'cuencas naturales' },
  { id: 'cuenta pública', label: 'cuenta pública' },
  { id: 'cuerpo', label: 'cuerpo' },
  { id: 'cuidar', label: 'cuidar' },
  { id: 'cultura', label: 'cultura' },
  { id: 'cultural', label: 'cultural' },
  { id: 'hombres', label: 'hombres' },
  { id: 'de hombres', label: 'de hombres' },
  { id: 'deberes ciudadanos', label: 'deberes ciudadanos' },
  { id: 'debido proceso', label: 'debido proceso' },
  { id: 'defender derechos', label: 'defender derechos' },
  { id: 'defender', label: 'defender' },
  { id: 'defensa nacional', label: 'defensa nacional' },
  { id: 'defensor del pueblo', label: 'defensor del pueblo' },
  { id: 'defensoría pública', label: 'defensoría pública' },
  { id: 'defensoría', label: 'defensoría' },
  { id: 'delincuencia', label: 'delincuencia' },
  { id: 'narcotráfico', label: 'narcotráfico' },
  { id: 'demandas', label: 'demandas' },
  { id: 'democracia', label: 'democracia' },
  { id: 'sociedad democrática', label: 'sociedad democrática' },
  { id: 'democracia moderna', label: 'democracia moderna' },
  { id: 'democracia directa', label: 'democracia directa' },
  { id: 'democracia participativa', label: 'democracia participativa' },
  { id: 'democracia representativa', label: 'democracia representativa' },
  { id: 'deporte', label: 'deporte' },
  { id: 'actividad física', label: 'actividad física' },
  { id: 'derecho individual', label: 'derecho individual' },
  { id: 'derecho', label: 'derecho' },
  { id: 'derechos', label: 'derechos' },
  { id: 'derechos básicos', label: 'derechos básicos' },
  { id: 'derechos civiles', label: 'derechos civiles' },
  { id: 'derechos constitucionales', label: 'derechos constitucionales' },
  { id: 'derechos económicos', label: 'derechos económicos' },
  { id: 'derechos fundamentales', label: 'derechos fundamentales' },
  { id: 'derechos inalienables', label: 'derechos inalienables' },
  { id: 'derechos laborales', label: 'derechos laborales' },
  { id: 'derechos sindicales', label: 'derechos sindicales' },
  { id: 'derechos sexuales y reproductivos', label: 'derechos sexuales y reproductivos' },
  { id: 'derechos sexuales', label: 'derechos sexuales' },
  { id: 'derechos reproductivos', label: 'derechos reproductivos' },
  { id: 'derechos sociales', label: 'derechos sociales' },
  { id: 'derechos universales', label: 'derechos universales' },
  { id: 'derechos garantizados', label: 'derechos garantizados' },
  { id: 'garantizar derechos', label: 'garantizar derechos' },
  { id: 'desafíos', label: 'desafíos' },
  { id: 'desarrollo', label: 'desarrollo' },
  { id: 'desarrollo del país', label: 'desarrollo del país' },
  { id: 'progreso', label: 'progreso' },
  { id: 'potenciar el desarrollo', label: 'potenciar el desarrollo' },
  { id: 'proyectos de desarrollo', label: 'proyectos de desarrollo' },
  { id: 'programas de desarrollo', label: 'programas de desarrollo' },
  { id: 'desarrollo armónico', label: 'desarrollo armónico' },
  { id: 'desarrollo cultural', label: 'desarrollo cultural' },
  { id: 'desarrollo económico', label: 'desarrollo económico' },
  { id: 'desarrollo económico sostenible', label: 'desarrollo económico sostenible' },
  { id: 'crecimiento económico', label: 'crecimiento económico' },
  { id: 'progreso económico', label: 'progreso económico' },
  { id: 'desarrollo humano', label: 'desarrollo humano' },
  { id: 'desarrollo social', label: 'desarrollo social' },
  { id: 'desarrollarse íntegramente', label: 'desarrollarse íntegramente' },
  { id: 'desarrollo intelectual', label: 'desarrollo intelectual' },
  { id: 'intelectual', label: 'intelectual' },
  { id: 'desarrollo científico', label: 'desarrollo científico' },
  { id: 'desarrollo de ciencias', label: 'desarrollo de ciencias' },
  { id: 'desarrollo personal', label: 'desarrollo personal' },
  { id: 'desarrollo individual', label: 'desarrollo individual' },
  { id: 'crecimiento personal', label: 'crecimiento personal' },
  { id: 'realización personal', label: 'realización personal' },
  { id: 'desarrollo sustentable', label: 'desarrollo sustentable' },
  { id: 'desarrollo sostenible', label: 'desarrollo sostenible' },
  { id: 'sustentabilidad', label: 'sustentabilidad' },
  { id: 'sustentabilidad del país', label: 'sustentabilidad del país' },
  { id: 'país sustentable', label: 'país sustentable' },
  { id: 'crecimiento sustentable', label: 'crecimiento sustentable' },
  { id: 'desarrollo territorial', label: 'desarrollo territorial' },
  { id: 'descentralización', label: 'descentralización' },
  { id: 'descentralización territorial', label: 'descentralización territorial' },
  { id: 'descentralización del poder', label: 'descentralización del poder' },
  { id: 'desconcentración', label: 'desconcentración' },
  { id: 'descontento', label: 'descontento' },
  { id: 'malestar', label: 'malestar' },
  { id: 'desigualdad', label: 'desigualdad' },
  { id: 'brechas de desigualdad', label: 'brechas de desigualdad' },
  { id: 'múltiples desigualdades', label: 'múltiples desigualdades' },
  { id: 'metro', label: 'metro' },
  { id: 'deuda histórica', label: 'deuda histórica' },
  { id: 'dictadura', label: 'dictadura' },
  { id: 'dietas parlamentarias', label: 'dietas parlamentarias' },
  { id: 'dietas', label: 'dietas' },
  { id: 'diferencias_sociales', label: 'diferencias sociales' },
  { id: 'diferencias', label: 'diferencias' },
  { id: 'diferencias individuales', label: 'diferencias individuales' },
  { id: 'diferencias culturales', label: 'diferencias culturales' },
  { id: 'diferencias económicas', label: 'diferencias económicas' },
  { id: 'dificultades', label: 'dificultades' },
  { id: 'dignidad', label: 'dignidad' },
  { id: 'dignidad humana', label: 'dignidad humana' },
  { id: 'sociedad digna', label: 'sociedad digna' },
  { id: 'dinero', label: 'dinero' },
  { id: 'dios', label: 'dios' },
  { id: 'dirigentes', label: 'dirigentes' },
  { id: 'discriminaciones arbitrarias', label: 'discriminaciones arbitrarias' },
  { id: 'diversidad', label: 'diversidad' },
  { id: 'diversidad cultural', label: 'diversidad cultural' },
  { id: 'diversidad étnica', label: 'diversidad étnica' },
  { id: 'diversidad sexual', label: 'diversidad sexual' },
  { id: 'diversidad social', label: 'diversidad social' },
  { id: 'docentes', label: 'docentes' },
  { id: 'profesores', label: 'profesores' },
  { id: 'donación de órganos', label: 'donación de órganos' },
  { id: 'economía sustentable', label: 'economía sustentable' },
  { id: 'sustentabilidad económica', label: 'sustentabilidad económica' },
  { id: 'económico', label: 'económico' },
  { id: 'ecosistemas', label: 'ecosistemas' },
  { id: 'educación', label: 'educación' },
  { id: 'educación ambiental', label: 'educación ambiental' },
  { id: 'educación cívica', label: 'educación cívica' },
  { id: 'educación digna', label: 'educación digna' },
  { id: 'educación igualitaria', label: 'educación igualitaria' },
  { id: 'educación gratuíta', label: 'educación gratuíta' },
  { id: 'educación integral', label: 'educación integral' },
  { id: 'educación laica', label: 'educación laica' },
  { id: 'educación privada', label: 'educación privada' },
  { id: 'educación particular subvencionada', label: 'educación particular subvencionada' },
  { id: 'educación pública', label: 'educación pública' },
  { id: 'educación pública gratuita', label: 'educación pública gratuita' },
  { id: 'eficiencia', label: 'eficiencia' },
  { id: 'eficacia', label: 'eficacia' },
  { id: 'el otro', label: 'el otro' },
  { id: 'del otro', label: 'del otro' },
  { id: 'aceptar al otro', label: 'aceptar al otro' },
  { id: 'elusión', label: 'elusión' },
  { id: 'elusión tributaria', label: 'elusión tributaria' },
  { id: 'emparejar la cancha', label: 'emparejar la cancha' },
  { id: 'nivelar la cancha', label: 'nivelar la cancha' },
  { id: 'empatía', label: 'empatía' },
  { id: 'empleador', label: 'empleador' },
  { id: 'empoderar', label: 'empoderar' },
  { id: 'emprendimiento', label: 'emprendimiento' },
  { id: 'empresarios', label: 'empresarios' },
  { id: 'empresas', label: 'empresas' },
  { id: 'empresas extranjeras', label: 'empresas extranjeras' },
  { id: 'empresas privadas', label: 'empresas privadas' },
  { id: 'empresas públicas', label: 'empresas públicas' },
  { id: 'empresas nacionales', label: 'empresas nacionales' },
  { id: 'energía', label: 'energía' },
  { id: 'energías renovables', label: 'energías renovables' },
  { id: 'energías limpias', label: 'energías limpias' },
  { id: 'enfermedad', label: 'enfermedad' },
  { id: 'personas enfermas', label: 'personas enfermas' },
  { id: 'enfermedades catastróficas', label: 'enfermedades catastróficas' },
  { id: 'entorno', label: 'entorno' },
  { id: 'entornos naturales', label: 'entornos naturales' },
  { id: 'entorno seguro', label: 'entorno seguro' },
  { id: 'ecológico', label: 'ecológico' },
  { id: 'equidad', label: 'equidad' },
  { id: 'equidad de género', label: 'equidad de género' },
  { id: 'feminismo', label: 'feminismo' },
  { id: 'equidad social', label: 'equidad social' },
  { id: 'equidad territorial', label: 'equidad territorial' },
  { id: 'equilibrio', label: 'equilibrio' },
  { id: 'equilibrio social', label: 'equilibrio social' },
  { id: 'escuchar', label: 'escuchar' },
  { id: 'esfuerzo', label: 'esfuerzo' },
  { id: 'espacios públicos', label: 'espacios públicos' },
  { id: 'lugares públicos', label: 'lugares públicos' },
  { id: 'especialistas', label: 'especialistas' },
  { id: 'estabilidad', label: 'estabilidad' },
  { id: 'estabilidad social', label: 'estabilidad social' },
  { id: 'establecimientos educacionales', label: 'establecimientos educacionales' },
  { id: 'colegios', label: 'colegios' },
  { id: 'liceos', label: 'liceos' },
  { id: 'instituciones educativas', label: 'instituciones educativas' },
  { id: 'escuelas', label: 'escuelas' },
  { id: 'estado de bienestar', label: 'estado de bienestar' },
  { id: 'mayor rol del estado', label: 'mayor rol del estado' },
  { id: 'estado de chile', label: 'estado de chile' },
  { id: 'rol del estado', label: 'rol del estado' },
  { id: 'estado garante', label: 'estado garante' },
  { id: 'garante', label: 'garante' },
  { id: 'estado solidario', label: 'estado solidario' },
  { id: 'estado de derecho', label: 'estado de derecho' },
  { id: 'estado de excepción', label: 'estado de excepción' },
  { id: 'estado descentralizado', label: 'estado descentralizado' },
  { id: 'estado desconcentrado', label: 'estado desconcentrado' },
  { id: 'estado federal', label: 'estado federal' },
  { id: 'federal', label: 'federal' },
  { id: 'sistema federal', label: 'sistema federal' },
  { id: 'estado laico', label: 'estado laico' },
  { id: 'estado moderno', label: 'estado moderno' },
  { id: 'moderno', label: 'moderno' },
  { id: 'estado plurinacional', label: 'estado plurinacional' },
  { id: 'plurinacional', label: 'plurinacional' },
  { id: 'estado subsidiario', label: 'estado subsidiario' },
  { id: 'rol subsidiario', label: 'rol subsidiario' },
  { id: 'subsidiaridad', label: 'subsidiaridad' },
  { id: 'estado unitario', label: 'estado unitario' },
  { id: 'gobierno unitario', label: 'gobierno unitario' },
  { id: 'estudiantes', label: 'estudiantes' },
  { id: 'alumnos', label: 'alumnos' },
  { id: 'ética', label: 'ética' },
  { id: 'eutanasia', label: 'eutanasia' },
  { id: 'evasión', label: 'evasión' },
  { id: 'evasión tributaria', label: 'evasión tributaria' },
  { id: 'evolución', label: 'evolución' },
  { id: 'exclusión', label: 'exclusión' },
  { id: 'explotación', label: 'explotación' },
  { id: 'explotación racional de recursos', label: 'explotación racional de recursos' },
  { id: 'explotación racional', label: 'explotación racional' },
  { id: 'extracción de recursos', label: 'extracción de recursos' },
  { id: 'sobre explotación', label: 'sobre explotación' },
  { id: 'sobreexplotar', label: 'sobreexplotar' },
  { id: 'expresiones culturales', label: 'expresiones culturales' },
  { id: 'extranjeros', label: 'extranjeros' },
  { id: 'extranjeros residentes', label: 'extranjeros residentes' },
  { id: 'residentes', label: 'residentes' },
  { id: 'familia', label: 'familia' },
  { id: 'bienestar familiar', label: 'bienestar familiar' },
  { id: 'farmacias', label: 'farmacias' },
  { id: 'fecundación', label: 'fecundación' },
  { id: 'felicidad', label: 'felicidad' },
  { id: 'financiamiento', label: 'financiamiento' },
  { id: 'fines de lucro', label: 'fines de lucro' },
  { id: 'sin lucro', label: 'sin lucro' },
  { id: 'fin al lucro', label: 'fin al lucro' },
  { id: 'lucro', label: 'lucro' },
  { id: 'fiscalía', label: 'fiscalía' },
  { id: 'fiscal nacional', label: 'fiscal nacional' },
  { id: 'fiscales regionales', label: 'fiscales regionales' },
  { id: 'fiscalización ciudadana', label: 'fiscalización ciudadana' },
  { id: 'control social', label: 'control social' },
  { id: 'fiscalizar', label: 'fiscalizar' },
  { id: 'atribuciones fiscalizadoras', label: 'atribuciones fiscalizadoras' },
  { id: 'flora y fauna', label: 'flora y fauna' },
  { id: 'plantas', label: 'plantas' },
  { id: 'nativa', label: 'nativa' },
  { id: 'vegetal', label: 'vegetal' },
  { id: 'especies nativas', label: 'especies nativas' },
  { id: 'fomento', label: 'fomento' },
  { id: 'fortalecer', label: 'fortalecer' },
  { id: 'fraternidad', label: 'fraternidad' },
  { id: 'fuerzas armadas', label: 'fuerzas armadas' },
  { id: 'militar', label: 'militar' },
  { id: 'funcionarios públicos', label: 'funcionarios públicos' },
  { id: 'administración pública', label: 'administración pública' },
  { id: 'futuras generaciones', label: 'futuras generaciones' },
  { id: 'nuevas generaciones', label: 'nuevas generaciones' },
  { id: 'generaciones', label: 'generaciones' },
  { id: 'futuro del país', label: 'futuro del país' },
  { id: 'futuro', label: 'futuro' },
  { id: 'construcción del futuro', label: 'construcción del futuro' },
  { id: 'visión de futuro', label: 'visión de futuro' },
  { id: 'garantías constitucionales', label: 'garantías constitucionales' },
  { id: 'garantizar', label: 'garantizar' },
  { id: 'género', label: 'género' },
  { id: 'cuotas de género', label: 'cuotas de género' },
  { id: 'gestación', label: 'gestación' },
  { id: 'glaciares', label: 'glaciares' },
  { id: 'global', label: 'global' },
  { id: 'mundo globalizado', label: 'mundo globalizado' },
  { id: 'sociedad globalizada', label: 'sociedad globalizada' },
  { id: 'gobierno central', label: 'gobierno central' },
  { id: 'estado central', label: 'estado central' },
  { id: 'gobierno local', label: 'gobierno local' },
  { id: 'gobierno regional', label: 'gobierno regional' },
  { id: 'grandes ciudades', label: 'grandes ciudades' },
  { id: 'santiago', label: 'santiago' },
  { id: 'grandes empresas', label: 'grandes empresas' },
  { id: 'gratuidad', label: 'gratuidad' },
  { id: 'grupos económicos', label: 'grupos económicos' },
  { id: 'grupos intermedios', label: 'grupos intermedios' },
  { id: 'cuerpos intermedios', label: 'cuerpos intermedios' },
  { id: 'organismos intermedios', label: 'organismos intermedios' },
  { id: 'grupos privilegiados', label: 'grupos privilegiados' },
  { id: 'personas privilegiadas', label: 'personas privilegiadas' },
  { id: 'privilegios ante la ley', label: 'privilegios ante la ley' },
  { id: 'privilegios', label: 'privilegios' },
  { id: 'grupos vulnerables', label: 'grupos vulnerables' },
  { id: 'personas con necesidades', label: 'personas con necesidades' },
  { id: 'situación de calle', label: 'situación de calle' },
  { id: 'desposeídos', label: 'desposeídos' },
  { id: 'los más necesitados', label: 'los más necesitados' },
  { id: 'marginados', label: 'marginados' },
  { id: 'habitar', label: 'habitar' },
  { id: 'hábitat', label: 'hábitat' },
  { id: 'hacerse cargo', label: 'hacerse cargo' },
  { id: 'hacerse responsable', label: 'hacerse responsable' },
  { id: 'hacinamiento', label: 'hacinamiento' },
  { id: 'herencia', label: 'herencia' },
  { id: 'hijos', label: 'hijos' },
  { id: 'historia', label: 'historia' },
  { id: 'hogar', label: 'hogar' },
  { id: 'honestidad', label: 'honestidad' },
  { id: 'honor', label: 'honor' },
  { id: 'honradez', label: 'honradez' },
  { id: 'hospitales públicos', label: 'hospitales públicos' },
  { id: 'hospitales', label: 'hospitales' },
  { id: 'consultorios', label: 'consultorios' },
  { id: 'huelga', label: 'huelga' },
  { id: 'huelga sin reemplazo', label: 'huelga sin reemplazo' },
  { id: 'humanidad', label: 'humanidad' },
  { id: 'identidad', label: 'identidad' },
  { id: 'raíces', label: 'raíces' },
  { id: 'identidad colectiva', label: 'identidad colectiva' },
  { id: 'identidad nacional', label: 'identidad nacional' },
  { id: 'idiosincracia', label: 'idiosincracia' },
  { id: 'identidad cultural', label: 'identidad cultural' },
  { id: 'identidad sexual', label: 'identidad sexual' },
  { id: 'iglesia católica', label: 'iglesia católica' },
  { id: 'iglesia evangélica', label: 'iglesia evangélica' },
  { id: 'evangélica', label: 'evangélica' },
  { id: 'iglesias', label: 'iglesias' },
  { id: 'igualdad', label: 'igualdad' },
  { id: 'igualdad de género', label: 'igualdad de género' },
  { id: 'igualdad de oportunidades', label: 'igualdad de oportunidades' },
  { id: 'mismas oportunidades', label: 'mismas oportunidades' },
  { id: 'oportunidades para todos', label: 'oportunidades para todos' },
  { id: 'igualdad de condiciones', label: 'igualdad de condiciones' },
  { id: 'condiciones equitativas', label: 'condiciones equitativas' },
  { id: 'oportunidades', label: 'oportunidades' },
  { id: 'igualdad social', label: 'igualdad social' },
  { id: 'impacto ambiental', label: 'impacto ambiental' },
  { id: 'impuestos', label: 'impuestos' },
  { id: 'pagar impuestos', label: 'pagar impuestos' },
  { id: 'fiscales', label: 'fiscales' },
  { id: 'tributación', label: 'tributación' },
  { id: 'obligaciones tributarias', label: 'obligaciones tributarias' },
  { id: 'deberes fiscales', label: 'deberes fiscales' },
  { id: 'inclusión', label: 'inclusión' },
  { id: 'inclusión social', label: 'inclusión social' },
  { id: 'independencia', label: 'independencia' },
  { id: 'individual', label: 'individual' },
  { id: 'individualismo', label: 'individualismo' },
  { id: 'industria', label: 'industria' },
  { id: 'industrialización del país', label: 'industrialización del país' },
  { id: 'inequidad social', label: 'inequidad social' },
  { id: 'inequidad', label: 'inequidad' },
  { id: 'infancia', label: 'infancia' },
  { id: 'infancia digna', label: 'infancia digna' },
  { id: 'información', label: 'información' },
  { id: 'información pública', label: 'información pública' },
  { id: 'información fidedigna', label: 'información fidedigna' },
  { id: 'información personal', label: 'información personal' },
  { id: 'informacion privada', label: 'informacion privada' },
  { id: 'infraestructura', label: 'infraestructura' },
  { id: 'iniciativa ciudadana de ley', label: 'iniciativa ciudadana de ley' },
  { id: 'iniciativa de ley', label: 'iniciativa de ley' },
  { id: 'iniciativa privada', label: 'iniciativa privada' },
  { id: 'iniciativa económica', label: 'iniciativa económica' },
  { id: 'injusticias', label: 'injusticias' },
  { id: 'innovación', label: 'innovación' },
  { id: 'inscripción automática', label: 'inscripción automática' },
  { id: 'inscripción voluntaria', label: 'inscripción voluntaria' },
  { id: 'inseguridad', label: 'inseguridad' },
  { id: 'institucionalidad', label: 'institucionalidad' },
  { id: 'instituciones privadas', label: 'instituciones privadas' },
  { id: 'instituciones públicas', label: 'instituciones públicas' },
  { id: 'aparato público', label: 'aparato público' },
  { id: 'integración', label: 'integración' },
  { id: 'integración social', label: 'integración social' },
  { id: 'integridad física', label: 'integridad física' },
  { id: 'interculturalidad', label: 'interculturalidad' },
  { id: 'interés general', label: 'interés general' },
  { id: 'objetivos comunes', label: 'objetivos comunes' },
  { id: 'intereses particulares', label: 'intereses particulares' },
  { id: 'internacional', label: 'internacional' },
  { id: 'intimidad', label: 'intimidad' },
  { id: 'isapres', label: 'isapres' },
  { id: 'jefe de estado', label: 'jefe de estado' },
  { id: 'jefe de gobierno', label: 'jefe de gobierno' },
  { id: 'jueces', label: 'jueces' },
  { id: 'juicio político', label: 'juicio político' },
  { id: 'juntas de vecinos', label: 'juntas de vecinos' },
  { id: 'justicia igualitaria', label: 'justicia igualitaria' },
  { id: 'justicia militar', label: 'justicia militar' },
  { id: 'justicia social', label: 'justicia social' },
  { id: 'juventud', label: 'juventud' },
  { id: 'jóvenes', label: 'jóvenes' },
  { id: 'laico', label: 'laico' },
  { id: 'legalidad', label: 'legalidad' },
  { id: 'legisladores', label: 'legisladores' },
  { id: 'legitimidad', label: 'legitimidad' },
  { id: 'lengua', label: 'lengua' },
  { id: 'ley', label: 'ley' },
  { id: 'ley reservada del cobre', label: 'ley reservada del cobre' },
  { id: 'leyes de transparencia', label: 'leyes de transparencia' },
  { id: 'leyes laborales', label: 'leyes laborales' },
  { id: 'igualdad ante la ley', label: 'igualdad ante la ley' },
  { id: 'leyes parejas para todos', label: 'leyes parejas para todos' },
  { id: 'libertad', label: 'libertad' },
  { id: 'libertad ambulatoria', label: 'libertad ambulatoria' },
  { id: 'libertad física', label: 'libertad física' },
  { id: 'libertad de conciencia', label: 'libertad de conciencia' },
  { id: 'libertad de pensamiento', label: 'libertad de pensamiento' },
  { id: 'libertad de culto', label: 'libertad de culto' },
  { id: 'libertad religiosa', label: 'libertad religiosa' },
  { id: 'libertad de elegir', label: 'libertad de elegir' },
  { id: 'libertad de enseñanza', label: 'libertad de enseñanza' },
  { id: 'libertad de educación', label: 'libertad de educación' },
  { id: 'proceso de enseñanza', label: 'proceso de enseñanza' },
  { id: 'programas escolares', label: 'programas escolares' },
  { id: 'libertad de expresión', label: 'libertad de expresión' },
  { id: 'libertad de opinar', label: 'libertad de opinar' },
  { id: 'libertad de actuar', label: 'libertad de actuar' },
  { id: 'manifestarse', label: 'manifestarse' },
  { id: 'actuar libremente', label: 'actuar libremente' },
  { id: 'libertad de prensa', label: 'libertad de prensa' },
  { id: 'libertad de información', label: 'libertad de información' },
  { id: 'pluralidad de medios', label: 'pluralidad de medios' },
  { id: 'libertad de reunión', label: 'libertad de reunión' },
  { id: 'libertad de manifestarse', label: 'libertad de manifestarse' },
  { id: 'libertad del otro', label: 'libertad del otro' },
  { id: 'libertad individual', label: 'libertad individual' },
  { id: 'libre competencia', label: 'libre competencia' },
  { id: 'libre iniciativa económica', label: 'libre iniciativa económica' },
  { id: 'libre intercambio comercial', label: 'libre intercambio comercial' },
  { id: 'libre mercado', label: 'libre mercado' },
  { id: 'libre de contaminación	sin contaminación', label: 'libre de contaminación	sin contaminación' },
  { id: 'liderazgo', label: 'liderazgo' },
  { id: 'limpieza', label: 'limpieza' },
  { id: 'listas de espera', label: 'listas de espera' },
  { id: 'litio', label: 'litio' },
  { id: 'lograr', label: 'lograr' },
  { id: 'machismo', label: 'machismo' },
  { id: 'madres', label: 'madres' },
  { id: 'malas prácticas', label: 'malas prácticas' },
  { id: 'mantener', label: 'mantener' },
  { id: 'mapuche', label: 'mapuche' },
  { id: 'nación mapuche', label: 'nación mapuche' },
  { id: 'mar', label: 'mar' },
  { id: 'materias primas', label: 'materias primas' },
  { id: 'maternidad', label: 'maternidad' },
  { id: 'matrimonio', label: 'matrimonio' },
  { id: 'cónyuges', label: 'cónyuges' },
  { id: 'mecanismos de control', label: 'mecanismos de control' },
  { id: 'fiscalización', label: 'fiscalización' },
  { id: 'mecanismos de fiscalización', label: 'mecanismos de fiscalización' },
  { id: 'mecanismos de participación', label: 'mecanismos de participación' },
  { id: 'mecanismos de reforma', label: 'mecanismos de reforma' },
  { id: 'medicamentos', label: 'medicamentos' },
  { id: 'remedios', label: 'remedios' },
  { id: 'medicina', label: 'medicina' },
  { id: 'médicos', label: 'médicos' },
  { id: 'medio ambiente limpio', label: 'medio ambiente limpio' },
  { id: 'medio ambiente saludable', label: 'medio ambiente saludable' },
  { id: 'medioambiente', label: 'medioambiente' },
  { id: 'medios de comunicación', label: 'medios de comunicación' },
  { id: 'memoria', label: 'memoria' },
  { id: 'memoria histórica', label: 'memoria histórica' },
  { id: 'salud mental', label: 'salud mental' },
  { id: 'mental', label: 'mental' },
  { id: 'síquica', label: 'síquica' },
  { id: 'sicológica', label: 'sicológica' },
  { id: 'mercado', label: 'mercado' },
  { id: 'meritocracia', label: 'meritocracia' },
  { id: 'mérito', label: 'mérito' },
  { id: 'migración', label: 'migración' },
  { id: 'inmigración', label: 'inmigración' },
  { id: 'minería', label: 'minería' },
  { id: 'ministerio público', label: 'ministerio público' },
  { id: 'minorías', label: 'minorías' },
  { id: 'minorías étnicas', label: 'minorías étnicas' },
  { id: 'minorías sexuales', label: 'minorías sexuales' },
  { id: 'modelo de desarrollo', label: 'modelo de desarrollo' },
  { id: 'modelo económico', label: 'modelo económico' },
  { id: 'modificar', label: 'modificar' },
  { id: 'monopolio', label: 'monopolio' },
  { id: 'monumentos históricos', label: 'monumentos históricos' },
  { id: 'monumentos', label: 'monumentos' },
  { id: 'moral', label: 'moral' },
  { id: 'movilidad social', label: 'movilidad social' },
  { id: 'movilidad', label: 'movilidad' },
  { id: 'muerte', label: 'muerte' },
  { id: 'muerte digna', label: 'muerte digna' },
  { id: 'muerte natural', label: 'muerte natural' },
  { id: 'mujeres', label: 'mujeres' },
  { id: 'multiculturalidad', label: 'multiculturalidad' },
  { id: 'sociedad multicultural', label: 'sociedad multicultural' },
  { id: 'pluricultural', label: 'pluricultural' },
  { id: 'municipal', label: 'municipal' },
  { id: 'nación', label: 'nación' },
  { id: 'nacional', label: 'nacional' },
  { id: 'nacionalidad', label: 'nacionalidad' },
  { id: 'nacionalización', label: 'nacionalización' },
  { id: 'nacionalización de recursos', label: 'nacionalización de recursos' },
  { id: 'naturaleza', label: 'naturaleza' },
  { id: 'riquezas naturales', label: 'riquezas naturales' },
  { id: 'necesidades básicas', label: 'necesidades básicas' },
  { id: 'necesidades', label: 'necesidades' },
  { id: 'satisfacción de necesidades', label: 'satisfacción de necesidades' },
  { id: 'necesidades especiales', label: 'necesidades especiales' },
  { id: 'necesidades locales', label: 'necesidades locales' },
  { id: 'negociación', label: 'negociación' },
  { id: 'negociación colectiva', label: 'negociación colectiva' },
  { id: 'neutralidad', label: 'neutralidad' },
  { id: 'niños niñas y adolescentes', label: 'niños niñas y adolescentes' },
  { id: 'adolescencia', label: 'adolescencia' },
  { id: 'niñez', label: 'niñez' },
  { id: 'menores de edad', label: 'menores de edad' },
  { id: 'no abusar', label: 'no abusar' },
  { id: 'evitar abusos', label: 'evitar abusos' },
  { id: 'que no haya abusos', label: 'que no haya abusos' },
  { id: 'derecho a la vida', label: 'derecho a la vida' },
  { id: 'no al aborto', label: 'no al aborto' },
  { id: 'vida humana', label: 'vida humana' },
  { id: 'interrupción del embarazo', label: 'interrupción del embarazo' },
  { id: 'no discriminar', label: 'no discriminar' },
  { id: 'sin discriminación', label: 'sin discriminación' },
  { id: 'sin distinción', label: 'sin distinción' },
  { id: 'prohibir la discriminación', label: 'prohibir la discriminación' },
  { id: 'no elitista', label: 'no elitista' },
  { id: 'terminar con afp', label: 'terminar con afp' },
  { id: 'no más afp', label: 'no más afp' },
  { id: 'no sexista', label: 'no sexista' },
  { id: 'no subsidiario', label: 'no subsidiario' },
  { id: 'notarios', label: 'notarios' },
  { id: 'nuevas necesidades', label: 'nuevas necesidades' },
  { id: 'nuevas tecnologías', label: 'nuevas tecnologías' },
  { id: 'tecnologías', label: 'tecnologías' },
  { id: 'redes sociales', label: 'redes sociales' },
  { id: 'internet', label: 'internet' },
  { id: 'desarrollo tecnológico', label: 'desarrollo tecnológico' },
  { id: 'uso de tecnologías', label: 'uso de tecnologías' },
  { id: 'número de parlamentarios', label: 'número de parlamentarios' },
  { id: 'obligatoriedad', label: 'obligatoriedad' },
  { id: 'oit', label: 'oit' },
  { id: 'onu', label: 'onu' },
  { id: 'naciones unidas', label: 'naciones unidas' },
  { id: 'opinar', label: 'opinar' },
  { id: 'a opinar', label: 'a opinar' },
  { id: 'opinión pública', label: 'opinión pública' },
  { id: 'oportunidades de desarrollo', label: 'oportunidades de desarrollo' },
  { id: 'oportunidades laborales', label: 'oportunidades laborales' },
  { id: 'orden', label: 'orden' },
  { id: 'orden público', label: 'orden público' },
  { id: 'orden social', label: 'orden social' },
  { id: 'ordenamiento jurídico', label: 'ordenamiento jurídico' },
  { id: 'jurídico', label: 'jurídico' },
  { id: 'ordenamiento', label: 'ordenamiento' },
  { id: 'organismos del estado', label: 'organismos del estado' },
  { id: 'organización del estado', label: 'organización del estado' },
  { id: 'organizaciones', label: 'organizaciones' },
  { id: 'organizaciones sociales', label: 'organizaciones sociales' },
  { id: 'organización social', label: 'organización social' },
  { id: 'actores sociales', label: 'actores sociales' },
  { id: 'colectivos sociales', label: 'colectivos sociales' },
  { id: 'organizaciones territoriales', label: 'organizaciones territoriales' },
  { id: 'movimientos sociales', label: 'movimientos sociales' },
  { id: 'movimientos', label: 'movimientos' },
  { id: 'organizarse', label: 'organizarse' },
  { id: 'órganos del estado', label: 'órganos del estado' },
  { id: 'orientación sexual', label: 'orientación sexual' },
  { id: 'origen', label: 'origen' },
  { id: 'origen social', label: 'origen social' },
  { id: 'pacto social', label: 'pacto social' },
  { id: 'padres', label: 'padres' },
  { id: 'país', label: 'país' },
  { id: 'país diverso', label: 'país diverso' },
  { id: 'país equitativo', label: 'país equitativo' },
  { id: 'país justo', label: 'país justo' },
  { id: 'país solidario', label: 'país solidario' },
  { id: 'país tranquilo', label: 'país tranquilo' },
  { id: 'paisaje local', label: 'paisaje local' },
  { id: 'paisaje', label: 'paisaje' },
  { id: 'paridad', label: 'paridad' },
  { id: 'parques', label: 'parques' },
  { id: 'participación ciudadana', label: 'participación ciudadana' },
  { id: 'participación', label: 'participación' },
  { id: 'participación social', label: 'participación social' },
  { id: 'participación cívica', label: 'participación cívica' },
  { id: 'participación constante', label: 'participación constante' },
  { id: 'sociedad participativa', label: 'sociedad participativa' },
  { id: 'procesos participativos', label: 'procesos participativos' },
  { id: 'participación ciudadana vinculante', label: 'participación ciudadana vinculante' },
  { id: 'carácter vinculante', label: 'carácter vinculante' },
  { id: 'consultas vinculantes', label: 'consultas vinculantes' },
  { id: 'mecanismos vinculantes', label: 'mecanismos vinculantes' },
  { id: 'participación real', label: 'participación real' },
  { id: 'participación local', label: 'participación local' },
  { id: 'decisiones locales', label: 'decisiones locales' },
  { id: 'consultas locales', label: 'consultas locales' },
  { id: 'partidos políticos', label: 'partidos políticos' },
  { id: 'partidos', label: 'partidos' },
  { id: 'paternidad', label: 'paternidad' },
  { id: 'patria', label: 'patria' },
  { id: 'patrimonial', label: 'patrimonial' },
  { id: 'patrimonio nacional', label: 'patrimonio nacional' },
  { id: 'patrimonio arquitectónico', label: 'patrimonio arquitectónico' },
  { id: 'arquitectónico', label: 'arquitectónico' },
  { id: 'patrimonio cultural', label: 'patrimonio cultural' },
  { id: 'herencia cultural', label: 'herencia cultural' },
  { id: 'riqueza cultural', label: 'riqueza cultural' },
  { id: 'legado cultural', label: 'legado cultural' },
  { id: 'patrimonio histórico', label: 'patrimonio histórico' },
  { id: 'legado histórico', label: 'legado histórico' },
  { id: 'patrimonio inmaterial', label: 'patrimonio inmaterial' },
  { id: 'patrimonio material', label: 'patrimonio material' },
  { id: 'patrimonio medioambiental', label: 'patrimonio medioambiental' },
  { id: 'patrimonio ambiental', label: 'patrimonio ambiental' },
  { id: 'patrimonio natural', label: 'patrimonio natural' },
  { id: 'paz', label: 'paz' },
  { id: 'paz ciudadana', label: 'paz ciudadana' },
  { id: 'paz social', label: 'paz social' },
  { id: 'pena de muerte', label: 'pena de muerte' },
  { id: 'penal', label: 'penal' },
  { id: 'cárcel', label: 'cárcel' },
  { id: 'pensiones', label: 'pensiones' },
  { id: 'jubilaciones', label: 'jubilaciones' },
  { id: 'previsión social', label: 'previsión social' },
  { id: 'previsionales', label: 'previsionales' },
  { id: 'pensiones dignas', label: 'pensiones dignas' },
  { id: 'jubilación digna', label: 'jubilación digna' },
  { id: 'pequeñas y medianas empresas', label: 'pequeñas y medianas empresas' },
  { id: 'pymes', label: 'pymes' },
  { id: 'persona', label: 'persona' },
  { id: 'persona humana', label: 'persona humana' },
  { id: 'persona natural', label: 'persona natural' },
  { id: 'personalidad', label: 'personalidad' },
  { id: 'personalidad jurídica', label: 'personalidad jurídica' },
  { id: 'pertenecer', label: 'pertenecer' },
  { id: 'pesca', label: 'pesca' },
  { id: 'ley de pesca', label: 'ley de pesca' },
  { id: 'recursos marinos', label: 'recursos marinos' },
  { id: 'planeta', label: 'planeta' },
  { id: 'planificación territorial', label: 'planificación territorial' },
  { id: 'planificación urbana', label: 'planificación urbana' },
  { id: 'planificar', label: 'planificar' },
  { id: 'playas', label: 'playas' },
  { id: 'plebiscitos', label: 'plebiscitos' },
  { id: 'pluralismo', label: 'pluralismo' },
  { id: 'pobreza', label: 'pobreza' },
  { id: 'poder	poder', label: 'poder	poder' },
  { id: 'político', label: 'político' },
  { id: 'poder civil', label: 'poder civil' },
  { id: 'poder económico', label: 'poder económico' },
  { id: 'poder ejecutivo', label: 'poder ejecutivo' },
  { id: 'poder judicial', label: 'poder judicial' },
  { id: 'judicial', label: 'judicial' },
  { id: 'poder en poder judicial', label: 'poder en poder judicial' },
  { id: 'poder legislativo', label: 'poder legislativo' },
  { id: 'legislativo', label: 'legislativo' },
  { id: 'función legislativa', label: 'función legislativa' },
  { id: 'poderes del estado', label: 'poderes del estado' },
  { id: 'separación de poderes', label: 'separación de poderes' },
  { id: 'poderes independientes', label: 'poderes independientes' },
  { id: 'fuerzas de orden', label: 'fuerzas de orden' },
  { id: 'carabineros de chile', label: 'carabineros de chile' },
  { id: 'carabineros', label: 'carabineros' },
  { id: 'pdi', label: 'pdi' },
  { id: 'policía de investigaciones', label: 'policía de investigaciones' },
  { id: 'policías', label: 'policías' },
  { id: 'uniformados', label: 'uniformados' },
  { id: 'política', label: 'política' },
  { id: 'políticas públicas', label: 'políticas públicas' },
  { id: 'políticos', label: 'políticos' },
  { id: 'popular', label: 'popular' },
  { id: 'preocupaciones', label: 'preocupaciones' },
  { id: 'preservar', label: 'preservar' },
  { id: 'presidencia', label: 'presidencia' },
  { id: 'poder presidencial', label: 'poder presidencial' },
  { id: 'rol del presidente', label: 'rol del presidente' },
  { id: 'prestaciones de salud', label: 'prestaciones de salud' },
  { id: 'planes de salud', label: 'planes de salud' },
  { id: 'presupuesto nacional', label: 'presupuesto nacional' },
  { id: 'presupuesto', label: 'presupuesto' },
  { id: 'ley de presupuesto nacional', label: 'ley de presupuesto nacional' },
  { id: 'presupuestos públicos', label: 'presupuestos públicos' },
  { id: 'prevención', label: 'prevención' },
  { id: 'primer ministro', label: 'primer ministro' },
  { id: 'principio de subsidiaridad', label: 'principio de subsidiaridad' },
  { id: 'principios', label: 'principios' },
  { id: 'prioridades', label: 'prioridades' },
  { id: 'privacidad', label: 'privacidad' },
  { id: 'privados de libertad', label: 'privados de libertad' },
  { id: 'reos', label: 'reos' },
  { id: 'privatización', label: 'privatización' },
  { id: 'probidad', label: 'probidad' },
  { id: 'probidad pública', label: 'probidad pública' },
  { id: 'proceso legislativo', label: 'proceso legislativo' },
  { id: 'tramitación de las leyes', label: 'tramitación de las leyes' },
  { id: 'procesos políticos', label: 'procesos políticos' },
  { id: 'procesos históricos', label: 'procesos históricos' },
  { id: 'productividad', label: 'productividad' },
  { id: 'profesionales', label: 'profesionales' },
  { id: 'profesionales de calidad', label: 'profesionales de calidad' },
  { id: 'profundizar', label: 'profundizar' },
  { id: 'profundizar la democracia', label: 'profundizar la democracia' },
  { id: 'prohibir', label: 'prohibir' },
  { id: 'prójimo', label: 'prójimo' },
  { id: 'promocionar', label: 'promocionar' },
  { id: 'promover', label: 'promover' },
  { id: 'propiedad', label: 'propiedad' },
  { id: 'propiedad del estado', label: 'propiedad del estado' },
  { id: 'propiedad colectiva', label: 'propiedad colectiva' },
  { id: 'propiedad privada', label: 'propiedad privada' },
  { id: 'protección judicial', label: 'protección judicial' },
  { id: 'proteger', label: 'proteger' },
  { id: 'mecanismos de protección', label: 'mecanismos de protección' },
  { id: 'proveer', label: 'proveer' },
  { id: 'gobierno provincial', label: 'gobierno provincial' },
  { id: 'provincial', label: 'provincial' },
  { id: 'proyecto de vida', label: 'proyecto de vida' },
  { id: 'proyecto país', label: 'proyecto país' },
  { id: 'proyectos', label: 'proyectos' },
  { id: 'proyectos de ley', label: 'proyectos de ley' },
  { id: 'proyectos educativos', label: 'proyectos educativos' },
  { id: 'proceso educativo', label: 'proceso educativo' },
  { id: 'modelo educativo', label: 'modelo educativo' },
  { id: 'pueblo', label: 'pueblo' },
  { id: 'pueblos originarios', label: 'pueblos originarios' },
  { id: 'indígenas', label: 'indígenas' },
  { id: 'originarios', label: 'originarios' },
  { id: 'comunidades indígenas', label: 'comunidades indígenas' },
  { id: 'puerta giratoria', label: 'puerta giratoria' },
  { id: 'quórums', label: 'quórums' },
  { id: 'quórums supra mayoritarios', label: 'quórums supra mayoritarios' },
  { id: 'rango constitucional', label: 'rango constitucional' },
  { id: 'raza', label: 'raza' },
  { id: 'color de piel', label: 'color de piel' },
  { id: 'realizarse', label: 'realizarse' },
  { id: 'reciclar', label: 'reciclar' },
  { id: 'reciprocidad', label: 'reciprocidad' },
  { id: 'reconocimiento', label: 'reconocimiento' },
  { id: 'rectitud', label: 'rectitud' },
  { id: 'recuperar', label: 'recuperar' },
  { id: 'recursos naturales', label: 'recursos naturales' },
  { id: 'recursos', label: 'recursos' },
  { id: 'recursos económicos', label: 'recursos económicos' },
  { id: 'recursos estratégicos', label: 'recursos estratégicos' },
  { id: 'recursos humanos', label: 'recursos humanos' },
  { id: 'bienes naturales', label: 'bienes naturales' },
  { id: 'recursos no renovables', label: 'recursos no renovables' },
  { id: 'recursos renovables', label: 'recursos renovables' },
  { id: 'recursos propios', label: 'recursos propios' },
  { id: 'redistribución', label: 'redistribución' },
  { id: 'redistribuir la riqueza', label: 'redistribuir la riqueza' },
  { id: 'justicia distributiva', label: 'justicia distributiva' },
  { id: 'reelección', label: 'reelección' },
  { id: 'reelección de alcaldes', label: 'reelección de alcaldes' },
  { id: 'reelección de diputados', label: 'reelección de diputados' },
  { id: 'referéndum', label: 'referéndum' },
  { id: 'referéndum revocatorio', label: 'referéndum revocatorio' },
  { id: 'revocar el mandato', label: 'revocar el mandato' },
  { id: 'reforma constitucional', label: 'reforma constitucional' },
  { id: 'cambio constitucional', label: 'cambio constitucional' },
  { id: 'reformar', label: 'reformar' },
  { id: 'régimen de gobierno', label: 'régimen de gobierno' },
  { id: 'régimen democrático', label: 'régimen democrático' },
  { id: 'régimen parlamentario', label: 'régimen parlamentario' },
  { id: 'parlamentarismo', label: 'parlamentarismo' },
  { id: 'régimen presidencial', label: 'régimen presidencial' },
  { id: 'presidencialismo', label: 'presidencialismo' },
  { id: 'sistema presidencial', label: 'sistema presidencial' },
  { id: 'régimen semi presidencial', label: 'régimen semi presidencial' },
  { id: 'semi presidencial', label: 'semi presidencial' },
  { id: 'regionalización', label: 'regionalización' },
  { id: 'reglas claras', label: 'reglas claras' },
  { id: 'regular', label: 'regular' },
  { id: 'rehabilitación del individuo', label: 'rehabilitación del individuo' },
  { id: 'rehabilitación', label: 'rehabilitación' },
  { id: 'reinserción social', label: 'reinserción social' },
  { id: 'religión', label: 'religión' },
  { id: 'rendición de cuentas', label: 'rendición de cuentas' },
  { id: 'representatividad de autoridades', label: 'representatividad de autoridades' },
  { id: 'representatividad', label: 'representatividad' },
  { id: 'república', label: 'república' },
  { id: 'república democrática', label: 'república democrática' },
  { id: 'república unitaria', label: 'república unitaria' },
  { id: 'reservas naturales', label: 'reservas naturales' },
  { id: 'resguardar', label: 'resguardar' },
  { id: 'respetar las leyes', label: 'respetar las leyes' },
  { id: 'cumplimiento de leyes', label: 'cumplimiento de leyes' },
  { id: 'aplicar las leyes', label: 'aplicar las leyes' },
  { id: 'subordinación a la ley', label: 'subordinación a la ley' },
  { id: 'obedecer las leyes', label: 'obedecer las leyes' },
  { id: 'respeto', label: 'respeto' },
  { id: 'obligación de respetar', label: 'obligación de respetar' },
  { id: 'respeto mutuo', label: 'respeto mutuo' },
  { id: 'responsabilidad', label: 'responsabilidad' },
  { id: 'responsabilidad individual', label: 'responsabilidad individual' },
  { id: 'responsabilidad social', label: 'responsabilidad social' },
  { id: 'responsabilidad social empresarial', label: 'responsabilidad social empresarial' },
  { id: 'responsabilidades ciudadanas', label: 'responsabilidades ciudadanas' },
  { id: 'responsabilidad cívica', label: 'responsabilidad cívica' },
  { id: 'restaurar', label: 'restaurar' },
  { id: 'restricciones', label: 'restricciones' },
  { id: 'retribución', label: 'retribución' },
  { id: 'riesgo', label: 'riesgo' },
  { id: 'riesgo permanente', label: 'riesgo permanente' },
  { id: 'ríos', label: 'ríos' },
  { id: 'riqueza', label: 'riqueza' },
  { id: 'rol fiscalizador', label: 'rol fiscalizador' },
  { id: 'rol social', label: 'rol social' },
  { id: 'salario digno', label: 'salario digno' },
  { id: 'remuneración digna', label: 'remuneración digna' },
  { id: 'sueldo digno', label: 'sueldo digno' },
  { id: 'remuneraciones', label: 'remuneraciones' },
  { id: 'salario máximo', label: 'salario máximo' },
  { id: 'salario mínimo', label: 'salario mínimo' },
  { id: 'salud', label: 'salud' },
  { id: 'salud de calidad', label: 'salud de calidad' },
  { id: 'salud digna', label: 'salud digna' },
  { id: 'salud física y mental', label: 'salud física y mental' },
  { id: 'salud física', label: 'salud física' },
  { id: 'salud gratuita', label: 'salud gratuita' },
  { id: 'salud integral', label: 'salud integral' },
  { id: 'salud preventiva', label: 'salud preventiva' },
  { id: 'salud oportuna', label: 'salud oportuna' },
  { id: 'salud privada', label: 'salud privada' },
  { id: 'clínicas', label: 'clínicas' },
  { id: 'salud pública	salud', label: 'salud pública	salud' },
  { id: 'pública gratuita', label: 'pública gratuita' },
  { id: 'auge', label: 'auge' },
  { id: 'saludable', label: 'saludable' },
  { id: 'segregación social', label: 'segregación social' },
  { id: 'segregación', label: 'segregación' },
  { id: 'seguridad', label: 'seguridad' },
  { id: 'seguridad nacional', label: 'seguridad nacional' },
  { id: 'seguridad interna', label: 'seguridad interna' },
  { id: 'seguridad personal', label: 'seguridad personal' },
  { id: 'seguridad social', label: 'seguridad social' },
  { id: 'protección social', label: 'protección social' },
  { id: 'semillas', label: 'semillas' },
  { id: 'sename', label: 'sename' },
  { id: 'sentirnos seguros', label: 'sentirnos seguros' },
  { id: 'ser humano', label: 'ser humano' },
  { id: 'seres sintientes', label: 'seres sintientes' },
  { id: 'seres vivos', label: 'seres vivos' },
  { id: 'servel', label: 'servel' },
  { id: 'servicio público', label: 'servicio público' },
  { id: 'sexista', label: 'sexista' },
  { id: 'sexualidad', label: 'sexualidad' },
  { id: 'educacion sexual', label: 'educacion sexual' },
  { id: 'símbolos patrios', label: 'símbolos patrios' },
  { id: 'sin privilegios', label: 'sin privilegios' },
  { id: 'que no hayan privilegios', label: 'que no hayan privilegios' },
  { id: 'sindicalización', label: 'sindicalización' },
  { id: 'sindicatos', label: 'sindicatos' },
  { id: 'organización sindical', label: 'organización sindical' },
  { id: 'gremios', label: 'gremios' },
  { id: 'sistema binominal', label: 'sistema binominal' },
  { id: 'binominal', label: 'binominal' },
  { id: 'sistema de gobierno', label: 'sistema de gobierno' },
  { id: 'sistema de justicia', label: 'sistema de justicia' },
  { id: 'sistema de pensiones', label: 'sistema de pensiones' },
  { id: 'fondos de pensiones', label: 'fondos de pensiones' },
  { id: 'sistema de salud', label: 'sistema de salud' },
  { id: 'sistema económico', label: 'sistema económico' },
  { id: 'sistema educativo', label: 'sistema educativo' },
  { id: 'sistema electoral', label: 'sistema electoral' },
  { id: 'soberanía', label: 'soberanía' },
  { id: 'soberanía popular', label: 'soberanía popular' },
  { id: 'voluntad popular', label: 'voluntad popular' },
  { id: 'soberanía territorial', label: 'soberanía territorial' },
  { id: 'sociedad', label: 'sociedad' },
  { id: 'sociedad civil', label: 'sociedad civil' },
  { id: 'sociedad civilizada', label: 'sociedad civilizada' },
  { id: 'sociedad sana', label: 'sociedad sana' },
  { id: 'sociedad desarrollada', label: 'sociedad desarrollada' },
  { id: 'sociedad moderna', label: 'sociedad moderna' },
  { id: 'sociedad justa', label: 'sociedad justa' },
  { id: 'sociedad igualitaria', label: 'sociedad igualitaria' },
  { id: 'solidaridad', label: 'solidaridad' },
  { id: 'sentido solidario', label: 'sentido solidario' },
  { id: 'soluciones', label: 'soluciones' },
  { id: 'soluciones reales', label: 'soluciones reales' },
  { id: 'sostenibilidad', label: 'sostenibilidad' },
  { id: 'subsuelo', label: 'subsuelo' },
  { id: 'suelo', label: 'suelo' },
  { id: 'sufragio universal', label: 'sufragio universal' },
  { id: 'televisión', label: 'televisión' },
  { id: 'tener voz', label: 'tener voz' },
  { id: 'a voz', label: 'a voz' },
  { id: 'voz ciudadana', label: 'voz ciudadana' },
  { id: 'territorio', label: 'territorio' },
  { id: 'territorial', label: 'territorial' },
  { id: 'territorio nacional', label: 'territorio nacional' },
  { id: 'terrorismo', label: 'terrorismo' },
  { id: 'tiempo libre', label: 'tiempo libre' },
  { id: 'ocio', label: 'ocio' },
  { id: 'descanso', label: 'descanso' },
  { id: 'recreación', label: 'recreación' },
  { id: 'esparcimiento', label: 'esparcimiento' },
  { id: 'tierras', label: 'tierras' },
  { id: 'titularidad sindical', label: 'titularidad sindical' },
  { id: 'tolerancia', label: 'tolerancia' },
  { id: 'trabajadores', label: 'trabajadores' },
  { id: 'empleado', label: 'empleado' },
  { id: 'trabajo', label: 'trabajo' },
  { id: 'empleo', label: 'empleo' },
  { id: 'laboral', label: 'laboral' },
  { id: 'trabajo decente', label: 'trabajo decente' },
  { id: 'estabilidad laboral', label: 'estabilidad laboral' },
  { id: 'jornada laboral', label: 'jornada laboral' },
  { id: 'lugares de trabajo', label: 'lugares de trabajo' },
  { id: 'doméstico	doméstico', label: 'doméstico	doméstico' },
  { id: 'tradiciones', label: 'tradiciones' },
  { id: 'tradiciones y costumbres', label: 'tradiciones y costumbres' },
  { id: 'tradición histórica', label: 'tradición histórica' },
  { id: 'costumbres', label: 'costumbres' },
  { id: 'tranquilidad', label: 'tranquilidad' },
  { id: 'transformación', label: 'transformación' },
  { id: 'transparencia', label: 'transparencia' },
  { id: 'accountability', label: 'accountability' },
  { id: 'transporte', label: 'transporte' },
  { id: 'tratados internacionales', label: 'tratados internacionales' },
  { id: 'acuerdos internacionales', label: 'acuerdos internacionales' },
  { id: 'obligaciones internacionales', label: 'obligaciones internacionales' },
  { id: 'convenios internacionales', label: 'convenios internacionales' },
  { id: 'tratados internacionales firmados', label: 'tratados internacionales firmados' },
  { id: 'cumplimiento de tratados', label: 'cumplimiento de tratados' },
  { id: 'trato digno', label: 'trato digno' },
  { id: 'trato igualitario', label: 'trato igualitario' },
  { id: 'trato equitativo', label: 'trato equitativo' },
  { id: 'ser tratados iguales', label: 'ser tratados iguales' },
  { id: 'trato justo', label: 'trato justo' },
  { id: 'tribunal constitucional', label: 'tribunal constitucional' },
  { id: 'tribunales de justicia', label: 'tribunales de justicia' },
  { id: 'tribunales', label: 'tribunales' },
  { id: 'tribunales militares', label: 'tribunales militares' },
  { id: 'turismo', label: 'turismo' },
  { id: 'unidad', label: 'unidad' },
  { id: 'unidad nacional', label: 'unidad nacional' },
  { id: 'universal', label: 'universal' },
  { id: 'universalidad', label: 'universalidad' },
  { id: 'universidades', label: 'universidades' },
  { id: 'uso responsable y sustentable', label: 'uso responsable y sustentable' },
  { id: 'uso responsable', label: 'uso responsable' },
  { id: 'uso racional', label: 'uso racional' },
  { id: 'uso responsable y planificado', label: 'uso responsable y planificado' },
  { id: 'valor agregado', label: 'valor agregado' },
  { id: 'valorar', label: 'valorar' },
  { id: 'valores cristianos', label: 'valores cristianos' },
  { id: 'cristianos', label: 'cristianos' },
  { id: 'vecinos', label: 'vecinos' },
  { id: 'vejez', label: 'vejez' },
  { id: 'vejez digna', label: 'vejez digna' },
  { id: 'vida', label: 'vida' },
  { id: 'vida digna', label: 'vida digna' },
  { id: 'vida sana', label: 'vida sana' },
  { id: 'violencia', label: 'violencia' },
  { id: 'maltrato', label: 'maltrato' },
  { id: 'violencia de género', label: 'violencia de género' },
  { id: 'patriarcado', label: 'patriarcado' },
  { id: 'violencia intrafamiliar', label: 'violencia intrafamiliar' },
  { id: 'virtud', label: 'virtud' },
  { id: 'vivienda', label: 'vivienda' },
  { id: 'vivienda digna', label: 'vivienda digna' },
  { id: 'viviendas de calidad', label: 'viviendas de calidad' },
  { id: 'vivienda social', label: 'vivienda social' },
  { id: 'vivir sin violencia', label: 'vivir sin violencia' },
  { id: 'vida sin violencia', label: 'vida sin violencia' },
  { id: 'sin violencia', label: 'sin violencia' },
  { id: 'voluntariado', label: 'voluntariado' },
  { id: 'voto voluntario', label: 'voto voluntario' },
  { id: 'voluntario', label: 'voluntario' },
  { id: 'votaciones', label: 'votaciones' },
  { id: 'voto obligatorio', label: 'voto obligatorio' },
  { id: 'obligación de votar', label: 'obligación de votar' },
  { id: 'vulnerabilidad', label: 'vulnerabilidad' },
  { id: 'zonas extremas', label: 'zonas extremas' },
  { id: '18 de octubre', label: '18 de octubre' },
{ id: 'abandono de deberes', label: 'abandono de deberes' },
{ id: 'abstención', label: 'abstención' },
{ id: 'acceso', label: 'acceso' },
{ id: 'acceso a la información', label: 'acceso a la información' },
{ id: 'acceso información', label: 'acceso información' },
{ id: 'acta', label: 'acta' },
{ id: 'actas', label: 'actas' },
{ id: 'actividad física', label: 'actividad física' },
{ id: 'activismo ambiental', label: 'activismo ambiental' },
{ id: 'acto simbólico', label: 'acto simbólico' },
{ id: 'acuerdo', label: 'acuerdo' },
{ id: 'acuerdo interno', label: 'acuerdo interno' },
{ id: 'acuerdos', label: 'acuerdos' },
{ id: 'administración', label: 'administración' },
{ id: 'adolescencia', label: 'adolescencia' },
{ id: 'adolescentes', label: 'adolescentes' },
{ id: 'aforo', label: 'aforo' },
{ id: 'afp', label: 'afp' },
{ id: 'afuch', label: 'afuch' },
{ id: 'agricultura', label: 'agricultura' },
{ id: 'agro', label: 'agro' },
{ id: 'agrupación', label: 'agrupación' },
{ id: 'alimentación', label: 'alimentación' },
{ id: 'almacenamiento de datos', label: 'almacenamiento de datos' },
{ id: 'amnistía', label: 'amnistía' },
{ id: 'ampliación de la mesa', label: 'ampliación de la mesa' },
{ id: 'animalismo', label: 'animalismo' },
{ id: 'anticorrupción', label: 'anticorrupción' },
{ id: 'antidemocracia', label: 'antidemocracia' },
{ id: 'anulación', label: 'anulación' },
{ id: 'apertura', label: 'apertura' },
{ id: 'apoyo técnico', label: 'apoyo técnico' },
{ id: 'archivo', label: 'archivo' },
{ id: 'arte', label: 'arte' },
{ id: 'artes', label: 'artes' },
{ id: 'artículos transitorios', label: 'artículos transitorios' },
{ id: 'asamblea territorial', label: 'asamblea territorial' },
{ id: 'asignaciones', label: 'asignaciones' },
{ id: 'asistencia', label: 'asistencia' },
{ id: 'audiencias', label: 'audiencias' },
{ id: 'audiovisual', label: 'audiovisual' },
{ id: 'auditoría', label: 'auditoría' },
{ id: 'ausencia', label: 'ausencia' },
{ id: 'austeridad', label: 'austeridad' },
{ id: 'auto', label: 'auto' },
{ id: 'autodeterminación', label: 'autodeterminación' },
{ id: 'autorizaciones', label: 'autorizaciones' },
{ id: 'autorización', label: 'autorización' },
{ id: 'ayuda', label: 'ayuda' },
{ id: 'banco central', label: 'banco central' },
{ id: 'banderas', label: 'banderas' },
{ id: 'biblioteca', label: 'biblioteca' },
{ id: 'bio-ecologia', label: 'bio-ecologia' },
{ id: 'boletines', label: 'boletines' },
{ id: 'boletín', label: 'boletín' },
{ id: 'buena fe', label: 'buena fe' },
{ id: 'cabildos', label: 'cabildos' },
{ id: 'consejo municipal', label: 'consejo municipal' },
{ id: 'camara de diputados', label: 'camara de diputados' },
{ id: 'cambio climatico', label: 'cambio climatico' },
{ id: 'cambio climático', label: 'cambio climático' },
{ id: 'campesinado', label: 'campesinado' },
{ id: 'canal de televisión', label: 'canal de televisión' },
{ id: 'carta', label: 'carta' },
{ id: 'carta de apoyo', label: 'carta de apoyo' },
{ id: 'carta magna', label: 'carta magna' },
{ id: 'cartas', label: 'cartas' },
{ id: 'casinos', label: 'casinos' },
{ id: 'celebración', label: 'celebración' },
{ id: 'ceremonia', label: 'ceremonia' },
{ id: 'certificado', label: 'certificado' },
{ id: 'certificado médico', label: 'certificado médico' },
{ id: 'chilenos en el extranjero', label: 'chilenos en el extranjero' },
{ id: 'chilenos en extranjero', label: 'chilenos en extranjero' },
{ id: 'choapa', label: 'choapa' },
{ id: 'ciberseguridad', label: 'ciberseguridad' },
{ id: 'ciclo de charlas', label: 'ciclo de charlas' },
{ id: 'ciencia', label: 'ciencia' },
{ id: 'ciencias', label: 'ciencias' },
{ id: 'cigarro', label: 'cigarro' },
{ id: 'ciudadania', label: 'ciudadania' },
{ id: 'colaboración', label: 'colaboración' },
{ id: 'colectivo', label: 'colectivo' },
{ id: 'comision', label: 'comision' },
{ id: 'comisiones', label: 'comisiones' },
{ id: 'comisiones transitorias', label: 'comisiones transitorias' },
{ id: 'comisión', label: 'comisión' },
{ id: 'comisión de comunicaciones', label: 'comisión de comunicaciones' },
{ id: 'comisión de servicio', label: 'comisión de servicio' },
{ id: 'comisión de ética', label: 'comisión de ética' },
{ id: 'comisión valech', label: 'comisión valech' },
{ id: 'comisones', label: 'comisones' },
{ id: 'comité de asignaciones', label: 'comité de asignaciones' },
{ id: 'comité de ética', label: 'comité de ética' },
{ id: 'comparado', label: 'comparado' },
{ id: 'comparando', label: 'comparando' },
{ id: 'complejo forestal', label: 'complejo forestal' },
{ id: 'compra', label: 'compra' },
{ id: 'compras', label: 'compras' },
{ id: 'comsión de ética', label: 'comsión de ética' },
{ id: 'comunicaciones', label: 'comunicaciones' },
{ id: 'comunicación', label: 'comunicación' },
{ id: 'comunidad sorda', label: 'comunidad sorda' },
{ id: 'conclusiones', label: 'conclusiones' },
{ id: 'congreso', label: 'congreso' },
{ id: 'constitucionalidad', label: 'constitucionalidad' },
{ id: 'constituciones', label: 'constituciones' },
{ id: 'constitución', label: 'constitución' },
{ id: 'consulta', label: 'consulta' },
{ id: 'consulta indigena', label: 'consulta indigena' },
{ id: 'consulta indígena', label: 'consulta indígena' },
{ id: 'consultas', label: 'consultas' },
{ id: 'consumo de drogas', label: 'consumo de drogas' },
{ id: 'contraloria', label: 'contraloria' },
{ id: 'contratación', label: 'contratación' },
{ id: 'contratación personal', label: 'contratación personal' },
{ id: 'convencionales constituyentes', label: 'convencionales constituyentes' },
{ id: 'convención constitucional', label: 'convención constitucional' },
{ id: 'convenio 169 oit', label: 'convenio 169 oit' },
{ id: 'convenios', label: 'convenios' },
{ id: 'convenios suscritos', label: 'convenios suscritos' },
{ id: 'conversatorios', label: 'conversatorios' },
{ id: 'convocatoria', label: 'convocatoria' },
{ id: 'coordinaciones', label: 'coordinaciones' },
{ id: 'coordinación', label: 'coordinación' },
{ id: 'coordinadores', label: 'coordinadores' },
{ id: 'correo electronico', label: 'correo electronico' },
{ id: 'covid', label: 'covid' },
{ id: 'covid-19', label: 'covid-19' },
{ id: 'credenciales', label: 'credenciales' },
{ id: 'crisis climática', label: 'crisis climática' },
{ id: 'crisis ecológica', label: 'crisis ecológica' },
{ id: 'crisis habitacional', label: 'crisis habitacional' },
{ id: 'cristianos', label: 'cristianos' },
{ id: 'cronograma', label: 'cronograma' },
{ id: 'cuencas', label: 'cuencas' },
{ id: 'cuenta', label: 'cuenta' },
{ id: 'culto religioso', label: 'culto religioso' },
{ id: 'cultura', label: 'cultura' },
{ id: 'curriculum', label: 'curriculum' },
{ id: 'cámara de diputados', label: 'cámara de diputados' },
{ id: 'cárcel', label: 'cárcel' },
{ id: 'datos personales', label: 'datos personales' },
{ id: 'debate', label: 'debate' },
{ id: 'debate constitucional', label: 'debate constitucional' },
{ id: 'declaración', label: 'declaración' },
{ id: 'declaración de intereses', label: 'declaración de intereses' },
{ id: 'declaración pública', label: 'declaración pública' },
{ id: 'delincuencia', label: 'delincuencia' },
{ id: 'democracia', label: 'democracia' },
{ id: 'democracia participativa', label: 'democracia participativa' },
{ id: 'dependencias', label: 'dependencias' },
{ id: 'deporte', label: 'deporte' },
{ id: 'derecho a la memoria', label: 'derecho a la memoria' },
{ id: 'derecho al agua', label: 'derecho al agua' },
{ id: 'derecho ambiental', label: 'derecho ambiental' },
{ id: 'derechos ambientales', label: 'derechos ambientales' },
{ id: 'derechos culturales', label: 'derechos culturales' },
{ id: 'derechos de los animales', label: 'derechos de los animales' },
{ id: 'derechos fundamentales', label: 'derechos fundamentales' },
{ id: 'derechos humanos', label: 'derechos humanos' },
{ id: 'verdad justicia y reparación', label: 'verdad justicia y reparación' },
{ id: 'derechos laborales', label: 'derechos laborales' },
{ id: 'derechos linguísticos', label: 'derechos linguísticos' },
{ id: 'derechos lingüísticos', label: 'derechos lingüísticos' },
{ id: 'derechos sexuales y reproductivos', label: 'derechos sexuales y reproductivos' },
{ id: 'desarrollo cultural', label: 'desarrollo cultural' },
{ id: 'desarrollo regional', label: 'desarrollo regional' },
{ id: 'descentralización', label: 'descentralización' },
{ id: 'descripción de sesiones', label: 'descripción de sesiones' },
{ id: 'designación', label: 'designación' },
{ id: 'desplazamiento', label: 'desplazamiento' },
{ id: 'dialogo', label: 'dialogo' },
{ id: 'diario de sesiones', label: 'diario de sesiones' },
{ id: 'dictadura', label: 'dictadura' },
{ id: 'dictadura militar', label: 'dictadura militar' },
{ id: 'dieta', label: 'dieta' },
{ id: 'dificil acceso', label: 'dificil acceso' },
{ id: 'dignidad sorda', label: 'dignidad sorda' },
{ id: 'diplomas', label: 'diplomas' },
{ id: 'directorio', label: 'directorio' },
{ id: 'discapacidad', label: 'discapacidad' },
{ id: 'discapacidad auditiva', label: 'discapacidad auditiva' },
{ id: 'discrimianción', label: 'discrimianción' },
{ id: 'discriminación', label: 'discriminación' },
{ id: 'disculpas públicas', label: 'disculpas públicas' },
{ id: 'discurso', label: 'discurso' },
{ id: 'discurso de odio', label: 'discurso de odio' },
{ id: 'discursos', label: 'discursos' },
{ id: 'discursos de apertura', label: 'discursos de apertura' },
{ id: 'discursos de odio', label: 'discursos de odio' },
{ id: 'diseño', label: 'diseño' },
{ id: 'diseño grafico', label: 'diseño grafico' },
{ id: 'disidencias sexuales', label: 'disidencias sexuales' },
{ id: 'distribución de salas', label: 'distribución de salas' },
{ id: 'documento', label: 'documento' },
{ id: 'donación', label: 'donación' },
{ id: 'dos tercios', label: 'dos tercios' },
{ id: 'drogas', label: 'drogas' },
{ id: 'ecología', label: 'ecología' },
{ id: 'eduación civica', label: 'eduación civica' },
{ id: 'educación', label: 'educación' },
{ id: 'educación inclusiva', label: 'educación inclusiva' },
{ id: 'educación popular', label: 'educación popular' },
{ id: 'educación pública', label: 'educación pública' },
{ id: 'ejecución presupuestaria', label: 'ejecución presupuestaria' },
{ id: 'ejecutados políticos', label: 'ejecutados políticos' },
{ id: 'ejecutiva', label: 'ejecutiva' },
{ id: 'elecciones', label: 'elecciones' },
{ id: 'elección', label: 'elección' },
{ id: 'enlaces tranversales', label: 'enlaces tranversales' },
{ id: 'participación popular', label: 'participación popular' },
{ id: 'elección, coordinación', label: 'elección, coordinación' },
{ id: 'emergencia climática', label: 'emergencia climática' },
{ id: 'enfermeras', label: 'enfermeras' },
{ id: 'enfermería', label: 'enfermería' },
{ id: 'enmiendas', label: 'enmiendas' },
{ id: 'equidad territorial', label: 'equidad territorial' },
{ id: 'escaños reservados', label: 'escaños reservados' },
{ id: 'escuela constituyente', label: 'escuela constituyente' },
{ id: 'escuelas', label: 'escuelas' },
{ id: 'espacio de senado', label: 'espacio de senado' },
{ id: 'espacios', label: 'espacios' },
{ id: 'espacios físicos', label: 'espacios físicos' },
{ id: 'estado de derecho', label: 'estado de derecho' },
{ id: 'estado plurinacional', label: 'estado plurinacional' },
{ id: 'estallido social', label: 'estallido social' },
{ id: 'exposición', label: 'exposición' },
{ id: 'expresión política', label: 'expresión política' },
{ id: 'fallecimiento', label: 'fallecimiento' },
{ id: 'familias', label: 'familias' },
{ id: 'federico santa maría', label: 'federico santa maría' },
{ id: 'felicitaciones', label: 'felicitaciones' },
{ id: 'feminismo', label: 'feminismo' },
{ id: 'fiestas patrias', label: 'fiestas patrias' },
{ id: 'financiaero', label: 'financiaero' },
{ id: 'financiamiento', label: 'financiamiento' },
{ id: 'financiero', label: 'financiero' },
{ id: 'finanzas', label: 'finanzas' },
{ id: 'fiscalización', label: 'fiscalización' },
{ id: 'foro', label: 'foro' },
{ id: 'francisca linconao', label: 'francisca linconao' },
{ id: 'fraternidad', label: 'fraternidad' },
{ id: 'fuerzas armadas', label: 'fuerzas armadas' },
{ id: 'funcionamiento', label: 'funcionamiento' },
{ id: 'función de apoyo', label: 'función de apoyo' },
{ id: 'futuro trabajo', label: 'futuro trabajo' },
{ id: 'garantía de no repetición', label: 'garantía de no repetición' },
{ id: 'gastos', label: 'gastos' },
{ id: 'gastos operacionales', label: 'gastos operacionales' },
{ id: 'geociencia', label: 'geociencia' },
{ id: 'geociencias', label: 'geociencias' },
{ id: 'geología', label: 'geología' },
{ id: 'guarderia infantil', label: 'guarderia infantil' },
{ id: 'hemiciclo', label: 'hemiciclo' },
{ id: 'hernán allende ponce', label: 'hernán allende ponce' },
{ id: 'herramientas', label: 'herramientas' },
{ id: 'himno nacional', label: 'himno nacional' },
{ id: 'honorarios', label: 'honorarios' },
{ id: 'horarios', label: 'horarios' },
{ id: 'identidad gráfica', label: 'identidad gráfica' },
{ id: 'ife laboral', label: 'ife laboral' },
{ id: 'iglesias', label: 'iglesias' },
{ id: 'impresoras', label: 'impresoras' },
{ id: 'impuestos', label: 'impuestos' },
{ id: 'inasistencia', label: 'inasistencia' },
{ id: 'inclusión', label: 'inclusión' },
{ id: 'inclusión territorial', label: 'inclusión territorial' },
{ id: 'independientes', label: 'independientes' },
{ id: 'indicaciones', label: 'indicaciones' },
{ id: 'indulto', label: 'indulto' },
{ id: 'infancia', label: 'infancia' },
{ id: 'información', label: 'información' },
{ id: 'información pública', label: 'información pública' },
{ id: 'información sensible', label: 'información sensible' },
{ id: 'informe', label: 'informe' },
{ id: 'informe parcial', label: 'informe parcial' },
{ id: 'informe territorial', label: 'informe territorial' },
{ id: 'informe técnico', label: 'informe técnico' },
{ id: 'informe valech', label: 'informe valech' },
{ id: 'informe, oficios', label: 'informe, oficios' },
{ id: 'informes', label: 'informes' },
{ id: 'infraestructura', label: 'infraestructura' },
{ id: 'ingreso', label: 'ingreso' },
{ id: 'inmigrantes', label: 'inmigrantes' },
{ id: 'instalaciones', label: 'instalaciones' },
{ id: 'instalación', label: 'instalación' },
{ id: 'instrucciones', label: 'instrucciones' },
{ id: 'instrucción', label: 'instrucción' },
{ id: 'integración', label: 'integración' },
{ id: 'interculturalidad', label: 'interculturalidad' },
{ id: 'invitaciones', label: 'invitaciones' },
{ id: 'invitación', label: 'invitación' },
{ id: 'isotipo', label: 'isotipo' },
{ id: 'jardín infantil', label: 'jardín infantil' },
{ id: 'jornada', label: 'jornada' },
{ id: 'jornada de relexión', label: 'jornada de relexión' },
{ id: 'justicia', label: 'justicia' },
{ id: 'justicia social', label: 'justicia social' },
{ id: 'justicia territorial', label: 'justicia territorial' },
{ id: 'justificación', label: 'justificación' },
{ id: 'justificativo', label: 'justificativo' },
{ id: 'lecciones', label: 'lecciones' },
{ id: 'lengua de señas', label: 'lengua de señas' },
{ id: 'ley 20.730', label: 'ley 20.730' },
{ id: 'ley de acceso', label: 'ley de acceso' },
{ id: 'ley de lobby', label: 'ley de lobby' },
{ id: 'ley longueira', label: 'ley longueira' },
{ id: 'libertad de enseñanza', label: 'libertad de enseñanza' },
{ id: 'libre de humo', label: 'libre de humo' },
{ id: 'libro', label: 'libro' },
{ id: 'libros', label: 'libros' },
{ id: 'licencia', label: 'licencia' },
{ id: 'licencia médica', label: 'licencia médica' },
{ id: 'licencias', label: 'licencias' },
{ id: 'lista del pueblo', label: 'lista del pueblo' },
{ id: 'lobby', label: 'lobby' },
{ id: 'lucro', label: 'lucro' },
{ id: 'límites de honorarios', label: 'límites de honorarios' },
{ id: 'macrozonasur', label: 'macrozonasur' },
{ id: 'maltrato', label: 'maltrato' },
{ id: 'manutención', label: 'manutención' },
{ id: 'material gráfico', label: 'material gráfico' },
{ id: 'matinal de televisión', label: 'matinal de televisión' },
{ id: 'mecanismo de elección', label: 'mecanismo de elección' },
{ id: 'mecanismos de corrección', label: 'mecanismos de corrección' },
{ id: 'medidas covid-19', label: 'medidas covid-19' },
{ id: 'medidas de protección', label: 'medidas de protección' },
{ id: 'medidas sanitarias', label: 'medidas sanitarias' },
{ id: 'medio ambiente', label: 'medio ambiente' },
{ id: 'medioambiente', label: 'medioambiente' },
{ id: 'medios de comunicación', label: 'medios de comunicación' },
{ id: 'metodología de participación', label: 'metodología de participación' },
{ id: 'metodologías de participación', label: 'metodologías de participación' },
{ id: 'ministerio de relaciones exteriores', label: 'ministerio de relaciones exteriores' },
{ id: 'minuta', label: 'minuta' },
{ id: 'minuto de silencio', label: 'minuto de silencio' },
{ id: 'moción', label: 'moción' },
{ id: 'modatima', label: 'modatima' },
{ id: 'modelo económico', label: 'modelo económico' },
{ id: 'modelo productivo', label: 'modelo productivo' },
{ id: 'modificación', label: 'modificación' },
{ id: 'monedas', label: 'monedas' },
{ id: 'mundo rural', label: 'mundo rural' },
{ id: 'municipalidades', label: 'municipalidades' },
{ id: 'nacionalidad', label: 'nacionalidad' },
{ id: 'naturaleza', label: 'naturaleza' },
{ id: 'negacionismo', label: 'negacionismo' },
{ id: 'niñez', label: 'niñez' },
{ id: 'niñez y adolescencia', label: 'niñez y adolescencia' },
{ id: 'no afp', label: 'no afp' },
{ id: 'no+ afp', label: 'no+ afp' },
{ id: 'norma', label: 'norma' },
{ id: 'norma transitoria', label: 'norma transitoria' },
{ id: 'normas', label: 'normas' },
{ id: 'notas', label: 'notas' },
{ id: 'nueva constitución', label: 'nueva constitución' },
{ id: 'nuevas comisiones', label: 'nuevas comisiones' },
{ id: 'numismática', label: 'numismática' },
{ id: 'oficio', label: 'oficio' },
{ id: 'oficios', label: 'oficios' },
{ id: 'online', label: 'online' },
{ id: 'oposición', label: 'oposición' },
{ id: 'orden', label: 'orden' },
{ id: 'ordinario', label: 'ordinario' },
{ id: 'organismos internacionales', label: 'organismos internacionales' },
{ id: 'organismos nacionales', label: 'organismos nacionales' },
{ id: 'organizaciones campesinas', label: 'organizaciones campesinas' },
{ id: 'organización', label: 'organización' },
{ id: 'organización sin fines de lucro', label: 'organización sin fines de lucro' },
{ id: 'osornotvmás', label: 'osornotvmás' },
{ id: 'palacio pereira', label: 'palacio pereira' },
{ id: 'pandemia', label: 'pandemia' },
{ id: 'paridad', label: 'paridad' },
{ id: 'participación', label: 'participación' },
{ id: 'participación  indígena', label: 'participación  indígena' },
{ id: 'participación de personas privadas de libertad', label: 'participación de personas privadas de libertad' },
{ id: 'participación indígena', label: 'participación indígena' },
{ id: 'participación infantil', label: 'participación infantil' },
{ id: 'participación social', label: 'participación social' },
{ id: 'paso a paso', label: 'paso a paso' },
{ id: 'patrimonio', label: 'patrimonio' },
{ id: 'patrimonio ecológico', label: 'patrimonio ecológico' },
{ id: 'patrocinios', label: 'patrocinios' },
{ id: 'pauta', label: 'pauta' },
{ id: 'pcr', label: 'pcr' },
{ id: 'penciones', label: 'penciones' },
{ id: 'pensiones', label: 'pensiones' },
{ id: 'personas con discapacidad', label: 'personas con discapacidad' },
{ id: 'personas privadas de libertad', label: 'personas privadas de libertad' },
{ id: 'personas sordas', label: 'personas sordas' },
{ id: 'perú', label: 'perú' },
{ id: 'pesca artesanal', label: 'pesca artesanal' },
{ id: 'pesqueras', label: 'pesqueras' },
{ id: 'pieza musical', label: 'pieza musical' },
{ id: 'piueblos originarios', label: 'piueblos originarios' },
{ id: 'plan paso a paso', label: 'plan paso a paso' },
{ id: 'plan regulador', label: 'plan regulador' },
{ id: 'planificación', label: 'planificación' },
{ id: 'plataformas digitales', label: 'plataformas digitales' },
{ id: 'plazos', label: 'plazos' },
{ id: 'plebiscito', label: 'plebiscito' },
{ id: 'pleno', label: 'pleno' },
{ id: 'pluralismo', label: 'pluralismo' },
{ id: 'plurinacional', label: 'plurinacional' },
{ id: 'plurinacionalidad', label: 'plurinacionalidad' },
{ id: 'poder constituido', label: 'poder constituido' },
{ id: 'postulación', label: 'postulación' },
{ id: 'prensa', label: 'prensa' },
{ id: 'presentación', label: 'presentación' },
{ id: 'presidencia', label: 'presidencia' },
{ id: 'presidente', label: 'presidente' },
{ id: 'preso de la revuelta', label: 'preso de la revuelta' },
{ id: 'presos de la revuelta', label: 'presos de la revuelta' },
{ id: 'presos mapuche', label: 'presos mapuche' },
{ id: 'presos políticos', label: 'presos políticos' },
{ id: 'presupuesto', label: 'presupuesto' },
{ id: 'presupuestos', label: 'presupuestos' },
{ id: 'previsión social', label: 'previsión social' },
{ id: 'prisioneros políticos', label: 'prisioneros políticos' },
{ id: 'probidad', label: 'probidad' },
{ id: 'proceso constituyente', label: 'proceso constituyente' },
{ id: 'proceso irregular', label: 'proceso irregular' },
{ id: 'procesos constitucionales', label: 'procesos constitucionales' },
{ id: 'proclamación', label: 'proclamación' },
{ id: 'profesores', label: 'profesores' },
{ id: 'programación', label: 'programación' },
{ id: 'propuesta', label: 'propuesta' },
{ id: 'propuestas', label: 'propuestas' },
{ id: 'protección', label: 'protección' },
{ id: 'protección de datos', label: 'protección de datos' },
{ id: 'proteción', label: 'proteción' },
{ id: 'protocolo', label: 'protocolo' },
{ id: 'protocolo covid', label: 'protocolo covid' },
{ id: 'proyectos educativos', label: 'proyectos educativos' },
{ id: 'publicación', label: 'publicación' },
{ id: 'pueblo afrodescendiente', label: 'pueblo afrodescendiente' },
{ id: 'pueblo constituyente', label: 'pueblo constituyente' },
{ id: 'pueblo tribal afrodescendiente', label: 'pueblo tribal afrodescendiente' },
{ id: 'pueblos indígenas', label: 'pueblos indígenas' },
{ id: 'pueblos originarios', label: 'pueblos originarios' },
{ id: 'quema de iglesias', label: 'quema de iglesias' },
{ id: 'quorum', label: 'quorum' },
{ id: 'quórum', label: 'quórum' },
{ id: 'racismo', label: 'racismo' },
{ id: 'rascismo', label: 'rascismo' },
{ id: 'ratificación', label: 'ratificación' },
{ id: 'reconocimiento', label: 'reconocimiento' },
{ id: 'rectores', label: 'rectores' },
{ id: 'recursos', label: 'recursos' },
{ id: 'redes sociales', label: 'redes sociales' },
{ id: 'reemplazos', label: 'reemplazos' },
{ id: 'reflamento', label: 'reflamento' },
{ id: 'reforma al reglamento', label: 'reforma al reglamento' },
{ id: 'regalo', label: 'regalo' },
{ id: 'regionalismo', label: 'regionalismo' },
{ id: 'reglamento', label: 'reglamento' },
{ id: 'reglamento general', label: 'reglamento general' },
{ id: 'reglamentos', label: 'reglamentos' },
{ id: 'reglas', label: 'reglas' },
{ id: 'relaciones exteriores', label: 'relaciones exteriores' },
{ id: 'religión', label: 'religión' },
{ id: 'remoto', label: 'remoto' },
{ id: 'remuneraciones', label: 'remuneraciones' },
{ id: 'renovación nacional', label: 'renovación nacional' },
{ id: 'renuncia', label: 'renuncia' },
{ id: 'reparación integral', label: 'reparación integral' },
{ id: 'representaciones', label: 'representaciones' },
{ id: 'representatividad', label: 'representatividad' },
{ id: 'requisitos', label: 'requisitos' },
{ id: 'resolución', label: 'resolución' },
{ id: 'respeto', label: 'respeto' },
{ id: 'resultados', label: 'resultados' },
{ id: 'retribuciones', label: 'retribuciones' },
{ id: 'reuniones', label: 'reuniones' },
{ id: 'rol de estado', label: 'rol de estado' },
{ id: 'sala', label: 'sala' },
{ id: 'salacuna', label: 'salacuna' },
{ id: 'salas', label: 'salas' },
{ id: 'salud', label: 'salud' },
{ id: 'secretaría', label: 'secretaría' },
{ id: 'secretaría administrativa', label: 'secretaría administrativa' },
{ id: 'seguridad', label: 'seguridad' },
{ id: 'seguridad pública', label: 'seguridad pública' },
{ id: 'semana territorial', label: 'semana territorial' },
{ id: 'senado', label: 'senado' },
{ id: 'servicios digitales', label: 'servicios digitales' },
{ id: 'sesion', label: 'sesion' },
{ id: 'sesiones', label: 'sesiones' },
{ id: 'sesión', label: 'sesión' },
{ id: 'sesión 20', label: 'sesión 20' },
{ id: 'sesión número  14', label: 'sesión número  14' },
{ id: 'sesión número  15', label: 'sesión número  15' },
{ id: 'sesión plenaria', label: 'sesión plenaria' },
{ id: 'sii', label: 'sii' },
{ id: 'sindicalismo', label: 'sindicalismo' },
{ id: 'sindicatos', label: 'sindicatos' },
{ id: 'sitios de memoria', label: 'sitios de memoria' },
{ id: 'sociedad civil', label: 'sociedad civil' },
{ id: 'sociologia', label: 'sociologia' },
{ id: 'solicitud', label: 'solicitud' },
{ id: 'solicitud de documentos', label: 'solicitud de documentos' },
{ id: 'soporte técnico', label: 'soporte técnico' },
{ id: 'suplente', label: 'suplente' },
{ id: 'sustentabilidad', label: 'sustentabilidad' },
{ id: 'sute chile', label: 'sute chile' },
{ id: 'tabaco', label: 'tabaco' },
{ id: 'tecnología', label: 'tecnología' },
{ id: 'telefonicos', label: 'telefonicos' },
{ id: 'teletrabajo', label: 'teletrabajo' },
{ id: 'televisión', label: 'televisión' },
{ id: 'temas emergentes', label: 'temas emergentes' },
{ id: 'temáticas constitucionales', label: 'temáticas constitucionales' },
{ id: 'territorio', label: 'territorio' },
{ id: 'territorios', label: 'territorios' },
{ id: 'territorios subnacionales', label: 'territorios subnacionales' },
{ id: 'terrorismo', label: 'terrorismo' },
{ id: 'tics', label: 'tics' },
{ id: 'titulares y suplentes', label: 'titulares y suplentes' },
{ id: 'toma de terrenos', label: 'toma de terrenos' },
{ id: 'tomas', label: 'tomas' },
{ id: 'trabajadores', label: 'trabajadores' },
{ id: 'trabajadores rurales', label: 'trabajadores rurales' },
{ id: 'transcripción', label: 'transcripción' },
{ id: 'transcripción de audiencias públicas', label: 'transcripción de audiencias públicas' },
{ id: 'transmisiones', label: 'transmisiones' },
{ id: 'transmisiones ', label: 'transmisiones' },
{ id: 'transmisión', label: 'transmisión' },
{ id: 'transparencia', label: 'transparencia' },
{ id: 'transparencias', label: 'transparencias' },
{ id: 'transporte', label: 'transporte' },
{ id: 'trato digno', label: 'trato digno' },
{ id: 'twitter', label: 'twitter' },
{ id: 'técnología', label: 'técnología' },
{ id: 'unicef', label: 'unicef' },
{ id: 'universidad', label: 'universidad' },
{ id: 'universidad de chile', label: 'universidad de chile' },
{ id: 'universidades', label: 'universidades' },
{ id: 'uso de la palabra', label: 'uso de la palabra' },
{ id: 'vacaciones', label: 'vacaciones' },
{ id: 'vacunación', label: 'vacunación' },
{ id: 'valech', label: 'valech' },
{ id: 'verdad histórica', label: 'verdad histórica' },
{ id: 'verdad y reparación', label: 'verdad y reparación' },
{ id: 'vicepresidencia', label: 'vicepresidencia' },
{ id: 'vicepresidencia adjunta', label: 'vicepresidencia adjunta' },
{ id: 'vicepresidencias', label: 'vicepresidencias' },
{ id: 'vicepresidencias adjuntas', label: 'vicepresidencias adjuntas' },
{ id: 'violencia', label: 'violencia' },
{ id: 'violencia de género', label: 'violencia de género' },
{ id: 'vivienda', label: 'vivienda' },
{ id: 'viviendas', label: 'viviendas' },
{ id: 'votacion', label: 'votacion' },
{ id: 'votaciones', label: 'votaciones' },
{ id: 'votación', label: 'votación' },
{ id: 'voto político', label: 'voto político' },
{ id: 'vínculo', label: 'vínculo' },
{ id: 'wallmapu', label: 'wallmapu' },
{ id: 'web', label: 'web' },
{ id: 'webinar', label: 'webinar' },
{ id: 'youtube', label: 'youtube' },
{ id: 'zona de sacrificio', label: 'zona de sacrificio' },
{ id: 'zoom', label: 'zoom' },
{ id: 'ética', label: 'ética' },
];

export default descriptors;
